import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import CryptoJS from "crypto-js";
import {
  getLocalStorageJSON,
  setLocalStorageJSON,
} from "../../../Utils/localStorageFunc";
import {
  FlightsResultPageErrorMain,
  FlightsResultPageErrorMainDescription,
  SearchBarErrorMessages,
  TravellerClasses,
  Travellers,
  TravellersFareMessage,
  fareOptions,
} from "../../../Constants/ConstantsFlights";
import {
  fetchPopularAirports,
  fetchTheAirline,
  fetchTheFlights,
  HoldTheFlight,
} from "../../Apis/Flight-Apis";
import {
  formatDateRecentSearch,
  formatDateToSeatchParams,
} from "../../../Utils/Date_Time_Calendar_Functions";
import {
  filterFlights,
  gerateFiltersParams,
  gerateFiltersParamsCombined,
  getAllAirlinesWithindex1,
  getTotalMinutes,
  sortByPrice,
} from "../../../Utils/Flight_results_func";

// searchTheFlightUrlCreator (below) rebuilds the results-page URL from scratch on every re-search
// from THIS page's own search bar (OnewaySearchBar.jsx etc., via window.location.replace) — it was
// missing &vc=/&pid= entirely, so re-searching from the results page silently dropped whatever
// region/currency the user had just picked in Header.jsx (both the URL and the actual backend
// request reverted to defaults) instead of carrying them forward like the homepage's own search
// does. Same localStorage keys/fallbacks as HomePage-Flights-SLICE.js's identical helpers.
const getSelectedCurrencyForUrl = () => getLocalStorageJSON("selectedCurrency") || "USD";
const getSelectedPipelineIdForUrl = () => getLocalStorageJSON("selectedPipelineCode") || "x";

let defaultsearchParams = [
  {
    OriginCity: "",
    DestinationCity: "",
    OriginCode: "",
    DestinyCode: "",
    Origin: "", // airport name
    Destiny: "", // airport name
    OriginCountryCode: "",
    DestinationCountryCode: "",
    OriginCountry: "",
    DestinationCountry: "",

    OriginDate: null, // convert date to this format,
    ReturnDate: null, // convert date to this format,
  },
  {
    OriginCity: "",
    DestinationCity: "",
    OriginCode: "",
    DestinyCode: "",
    Origin: "",
    Destiny: "",
    OriginCountryCode: "",
    DestinationCountryCode: "",
    OriginCountry: "",
    DestinationCountry: "",
    OriginDate: null, // convert date to this format,
    ReturnDate: null, // convert date to this format,
  },
  {
    OriginCity: "",
    DestinationCity: "",
    OriginCode: "",
    DestinyCode: "",
    Origin: "",
    Destiny: "",
    OriginCountryCode: "",
    DestinationCountryCode: "",
    OriginCountry: "",
    DestinationCountry: "",
    OriginDate: null, // convert date to this format,
    ReturnDate: null, // convert date to this format,
  },
  {
    OriginCity: "",
    DestinationCity: "",
    OriginCode: "",
    DestinyCode: "",
    Origin: "",
    Destiny: "",
    OriginCountryCode: "",
    DestinationCountryCode: "",
    OriginCountry: "",
    DestinationCountry: "",
    OriginDate: null, // convert date to this format,
    ReturnDate: null, // convert date to this format,
  },
];

let defaultsearchParamsTravellers = {
  Adults: 1,
  Childs: 0,
  Infrants: 0,
  TravellersAndClassesErrorOut: false,
  TravellersAndClassesErrorOutMessage: "",
  TravellersAndClassesErrorIn: false,
  TravellersAndClassesErrorInMessage: "",
};

let defaultsearchParamsFare = {
  class: "Economy",
  type: "Regular",
};

const initialState = {
  isOffline: false,
  // Search bar Inital States
  searchBarMode: 1,

  searchParams: defaultsearchParams,

  searchParamsTravellers: defaultsearchParamsTravellers,
  searchParamsFare: defaultsearchParamsFare,

  popularCitiesLoading: true,
  popularAirports: [],

  disableSearch: true,

  AirportsToError1: [false, ""],
  AirportsToError2: [false, ""],
  AirportsToError3: [false, ""],
  AirportsToError4: [false, ""],

  AirportsFromError1: [false, ""],
  AirportsFromError2: [false, ""],
  AirportsFromError3: [false, ""],
  AirportsFromError4: [false, ""],

  DateError1: [false, ""],
  DateError11: [false, ""],
  DateError2: [false, ""],
  DateError3: [false, ""],
  DateError4: [false, ""],

  multiRowNumber: 1,

  searchClicked: false,

  // Result Page Initial States
  PageTheme: 1,
  ErrorOnresultPage: false,
  ErrorOnresultPageMessageType: "",
  ErrorOnresultPageMessageDetailed: "",

  SearchParameters: [],
  StartTheSearch: false,
  SearchResultsStatus: "Loading",
  // SearchResultsStatus: "idle",
  SearchResults: null,

  SearchResultType: 1,

  searchkey: "",

  //  1 for combined view  ,  2 for split view
  ResultView: 1,

  filtersLoading: true,
  filtersGenerated: [],
  FilteredData: [],
  // TEMPORARY debug filter — "More than 1 FF" checkbox (Popular Filters sidebar) — shows only
  // items whose FareFamilies.FFList has more than 1 entry, to help find real multi-fare-family
  // test items while the per-fare-family Markup/Less work is being verified. Not wired into the
  // real FiltersApplied/generateFiltersAsync engine — plain client-side filter, remove once no
  // longer needed.
  // Array, not a single boolean — each leg/row gets its own independent toggle (index 0-3, same
  // per-bucket-index convention as FiltersApplied/barModeData below): [0] = Oneway/Onward/Row1,
  // [1] = Return/Row2, [2] = Row3 (multi-city), [3] = Row4 (multi-city).
  onlyMultiFF: [false, false, false, false],
  FullDataInitial: [],
  FiltersApplied: [[], [], [], [], [], [], [], []],

  barModeSelected: 0,
  barModeData: [[], [], [], []],

  openMainPopup: false,
  dataMainPopup: false,
  ResultTypeMainPopup: false,
  FFSelected: [0, 0, 0, 0],

  bookLoading: false,
  bookLoadingError: false,
  // null => BottomBar/index.js falls back to its own default "Please Try Again After Some Time"
  // text; set to a specific string (e.g. holdTheFlight()'s RES_EXPIRED "Your flight results are
  // expired..." message) when the backend sent one worth showing verbatim instead.
  bookLoadingErrorMessage: null,

  itrCode: "",
};

export const SearchTheFlights = createAsyncThunk(
  "HomePageSearchBarFlight/SearchTheFlights",
  async (params, { rejectWithValue, getState, signal }) => {
    try {
      // Single central point every real search (Homepage's initial load into the Results
      // page, and every re-search from the 3 Results-page search bars) funnels through — so
      // tagging AdminId here, instead of in each page's own search-building code, covers all
      // of them at once. Only set when an admin is actually logged in (see User-SLICE.js's
      // isAdminLogin/userLoggedInData, populated by the SSO exchange); never sent for a real
      // customer search. Backend: FlightMasterController::addFlightSearch2() reads
      // $request['AdminId'] into flight_searches.admin_id (nullable) when present.
      const { user } = getState();
      const requestParams =
        user?.isAdminLogin && user?.userLoggedInData?.id
          ? { ...params, AdminId: user.userLoggedInData.id }
          : params;

      // `signal` is createAsyncThunk's own AbortSignal — automatically aborted when the
      // dispatched action's `.abort()` is called (see ResultPage.jsx's browser back/forward/
      // tab-close handling), which flows straight into axios so the actual in-flight request
      // gets cancelled too, not just the Redux bookkeeping around it.
      const response = await fetchTheFlights(requestParams, signal);
      console.log("response got is  : ", response);
      return response?.data === undefined ? null : response?.data;
    } catch (error) {
      // A user-triggered abort isn't a real error — no need to surface it as one (no toast/error
      // page); the component that dispatched this already knows it cancelled the search itself.
      if (error?.code === "ERR_CANCELED" || error?.name === "CanceledError") {
        throw rejectWithValue({ aborted: true });
      }
      console.log("reached here for erorro the erorr is  : ", error);
      throw rejectWithValue({
        dd:
          error?.response?.data === undefined
            ? FlightsResultPageErrorMain.SRD
            : error?.response?.data,
        errorcode:
          error?.response?.data === undefined
            ? FlightsResultPageErrorMain.SRD
            : error?.code,
      });
    }
  }
);

export const setFiltersApplied = (payload) => {
  return async (dispatch, getState) => {
    const statesData = getState();

    let { ResultPageFlightsFlight } = statesData;

    let state = ResultPageFlightsFlight;
    let AppliedFilters = [...state.FiltersApplied.map((filter) => [...filter])];

    const { index, key, value, mode } = payload;

    let DatatoFilter = state.FullDataInitial;
    let FilteredData = state.FilteredData;

    if (
      mode === "Price" ||
      mode === "Duration" ||
      mode === "DurationLayover" ||
      mode === "SortBy" ||
      mode === "SearchBy"
    ) {
      // Find the index of the element with the matching key

      const existingIndex = AppliedFilters[index].findIndex(
        (item) => item.key === key
      );

      if (existingIndex !== -1) {
        // Remove the element with the matching key
        AppliedFilters[index] = [
          ...AppliedFilters[index].slice(0, existingIndex),
          ...AppliedFilters[index].slice(existingIndex + 1),
        ];
      }

      // Add the new element
      AppliedFilters[index] = [
        ...AppliedFilters[index],
        { Mode: mode, key: key, Value: value, Index: index },
      ];

      dispatch(setFiltersAppliedManual(AppliedFilters));

      if (state.SearchResultType === 1 || state.SearchResultType === 2) {
        let filteredData = filterFlights(
          DatatoFilter,
          AppliedFilters,
          index,
          state.SearchResultType
        );
        dispatch(setFilteredData(filteredData));
      } else if (state.SearchResultType === 3) {
        let filteredData = {
          Going:
            index === 0
              ? filterFlights(
                  DatatoFilter.Going,
                  AppliedFilters,
                  index,
                  state.SearchResultType
                )
              : FilteredData.Going,
          Returning:
            index === 1
              ? filterFlights(
                  DatatoFilter.Returning,
                  AppliedFilters,
                  index,
                  state.SearchResultType
                )
              : FilteredData.Returning,
        };

        dispatch(setFilteredData(filteredData));
      } else if (state.SearchResultType === 4) {
        let filteredData = [];

        if (index < 2) {
          filteredData = {
            ...FilteredData,
            Combined: filterFlights(
              DatatoFilter.Combined,
              AppliedFilters,
              index,
              state.SearchResultType
            ),
          };
        } else if (index === 2) {
          filteredData = {
            ...FilteredData,
            Split: {
              ...FilteredData.Split,
              Going: filterFlights(
                DatatoFilter.Split.Going,
                AppliedFilters,
                index,
                state.SearchResultType
              ),
            },
          };
        } else if (index === 3) {
          filteredData = {
            ...FilteredData,
            Split: {
              ...FilteredData.Split,
              Returning: filterFlights(
                DatatoFilter.Split.Returning,
                AppliedFilters,
                index,
                state.SearchResultType
              ),
            },
          };
        }

        dispatch(setFilteredData(filteredData));
      } else if (state.SearchResultType === 5) {
        let filteredData = [];

        if (index === 0) {
          filteredData = {
            ...FilteredData,
            Row1: filterFlights(
              DatatoFilter.Row1,
              AppliedFilters,
              index,
              state.SearchResultType
            ),
          };
        } else if (index === 1) {
          filteredData = {
            ...FilteredData,
            Row2: filterFlights(
              DatatoFilter.Row2,
              AppliedFilters,
              index,
              state.SearchResultType
            ),
          };
        }

        dispatch(setFilteredData(filteredData));
      } else if (state.SearchResultType === 6) {
        let filteredData = [];

        if (index < 2) {
          filteredData = {
            ...FilteredData,
            Combined: filterFlights(
              DatatoFilter.Combined,
              AppliedFilters,
              index,
              state.SearchResultType
            ),
          };
        } else if (index === 2) {
          filteredData = {
            ...FilteredData,
            Split: {
              ...FilteredData.Split,
              Row1: filterFlights(
                DatatoFilter.Split.Row1,
                AppliedFilters,
                index,
                state.SearchResultType
              ),
            },
          };
        } else if (index === 3) {
          filteredData = {
            ...FilteredData,
            Split: {
              ...FilteredData.Split,
              Row2: filterFlights(
                DatatoFilter.Split.Row2,
                AppliedFilters,
                index,
                state.SearchResultType
              ),
            },
          };
        }

        dispatch(setFilteredData(filteredData));
      } else if (state.SearchResultType === 7) {
        let filteredData = [];

        if (index === 0) {
          filteredData = {
            ...FilteredData,
            Row1: filterFlights(
              DatatoFilter.Row1,
              AppliedFilters,
              index,
              state.SearchResultType
            ),
          };
        } else if (index === 1) {
          filteredData = {
            ...FilteredData,
            Row2: filterFlights(
              DatatoFilter.Row2,
              AppliedFilters,
              index,
              state.SearchResultType
            ),
          };
        } else if (index === 2) {
          filteredData = {
            ...FilteredData,
            Row3: filterFlights(
              DatatoFilter.Row3,
              AppliedFilters,
              index,
              state.SearchResultType
            ),
          };
        }

        dispatch(setFilteredData(filteredData));
      } else if (state.SearchResultType === 8) {
        let filteredData = [];

        if (index < 3) {
          filteredData = {
            ...FilteredData,
            Combined: filterFlights(
              DatatoFilter.Combined,
              AppliedFilters,
              index,
              state.SearchResultType
            ),
          };
        } else if (index === 3) {
          filteredData = {
            ...FilteredData,
            Split: {
              ...FilteredData.Split,
              Row1: filterFlights(
                DatatoFilter.Split.Row1,
                AppliedFilters,
                index,
                state.SearchResultType
              ),
            },
          };
        } else if (index === 4) {
          filteredData = {
            ...FilteredData,
            Split: {
              ...FilteredData.Split,
              Row2: filterFlights(
                DatatoFilter.Split.Row2,
                AppliedFilters,
                index,
                state.SearchResultType
              ),
            },
          };
        } else if (index === 5) {
          filteredData = {
            ...FilteredData,
            Split: {
              ...FilteredData.Split,
              Row3: filterFlights(
                DatatoFilter.Split.Row3,
                AppliedFilters,
                index,
                state.SearchResultType
              ),
            },
          };
        }

        dispatch(setFilteredData(filteredData));
      } else if (state.SearchResultType === 9) {
        let filteredData = [];

        if (index === 0) {
          filteredData = {
            ...FilteredData,
            Row1: filterFlights(
              DatatoFilter.Row1,
              AppliedFilters,
              index,
              state.SearchResultType
            ),
          };
        } else if (index === 1) {
          filteredData = {
            ...FilteredData,
            Row2: filterFlights(
              DatatoFilter.Row2,
              AppliedFilters,
              index,
              state.SearchResultType
            ),
          };
        } else if (index === 2) {
          filteredData = {
            ...FilteredData,
            Row3: filterFlights(
              DatatoFilter.Row3,
              AppliedFilters,
              index,
              state.SearchResultType
            ),
          };
        } else if (index === 3) {
          filteredData = {
            ...FilteredData,
            Row4: filterFlights(
              DatatoFilter.Row4,
              AppliedFilters,
              index,
              state.SearchResultType
            ),
          };
        }

        dispatch(setFilteredData(filteredData));
      } else if (state.SearchResultType === 10) {
        let filteredData = [];

        if (index < 4) {
          filteredData = {
            ...FilteredData,
            Combined: filterFlights(
              DatatoFilter.Combined,
              AppliedFilters,
              index,
              state.SearchResultType
            ),
          };
        } else if (index === 4) {
          filteredData = {
            ...FilteredData,
            Split: {
              ...FilteredData.Split,
              Row1: filterFlights(
                DatatoFilter.Split.Row1,
                AppliedFilters,
                index,
                state.SearchResultType
              ),
            },
          };
        } else if (index === 5) {
          filteredData = {
            ...FilteredData,
            Split: {
              ...FilteredData.Split,
              Row2: filterFlights(
                DatatoFilter.Split.Row2,
                AppliedFilters,
                index,
                state.SearchResultType
              ),
            },
          };
        } else if (index === 6) {
          filteredData = {
            ...FilteredData,
            Split: {
              ...FilteredData.Split,
              Row3: filterFlights(
                DatatoFilter.Split.Row3,
                AppliedFilters,
                index,
                state.SearchResultType
              ),
            },
          };
        } else if (index === 7) {
          filteredData = {
            ...FilteredData,
            Split: {
              ...FilteredData.Split,
              Row4: filterFlights(
                DatatoFilter.Split.Row4,
                AppliedFilters,
                index,
                state.SearchResultType
              ),
            },
          };
        }

        dispatch(setFilteredData(filteredData));
      }
      return;
    }

    // Find the filter index that matches the mode and key
    const existingFilterIndex = AppliedFilters[index].findIndex(
      (filter) => filter.Mode === mode && filter.key === key
    );

    // If the filter exists, remove it
    if (existingFilterIndex !== -1) {
      AppliedFilters[index] = [
        ...AppliedFilters[index].slice(0, existingFilterIndex),
        ...AppliedFilters[index].slice(existingFilterIndex + 1),
      ];
    } else {
      AppliedFilters[index] = [
        ...AppliedFilters[index],
        { Mode: mode, key: key, Value: value, Index: index },
      ];
    }

    // Set the Data Acc To The Filters Applied
    if (state.SearchResultType === 1 || state.SearchResultType === 2) {
      let filteredData = filterFlights(
        DatatoFilter,
        AppliedFilters,
        index,
        state.SearchResultType
      );

      dispatch(setFiltersAppliedManual(AppliedFilters));
      dispatch(setFilteredData(filteredData));
    } else if (state.SearchResultType === 3) {
      let filteredData = {
        Going:
          index === 0
            ? filterFlights(
                DatatoFilter.Going,
                AppliedFilters,
                index,
                state.SearchResultType
              )
            : FilteredData.Going,
        Returning:
          index === 1
            ? filterFlights(
                DatatoFilter.Returning,
                AppliedFilters,
                index,
                state.SearchResultType
              )
            : FilteredData.Returning,
      };

      dispatch(setFiltersAppliedManual(AppliedFilters));
      dispatch(setFilteredData(filteredData));
    } else if (state.SearchResultType === 4) {
      let filteredData = {};

      if (index < 2) {
        filteredData = {
          ...FilteredData,
          Combined: filterFlights(
            DatatoFilter.Combined,
            AppliedFilters,
            index,
            state.SearchResultType
          ),
        };
      } else if (index === 2) {
        filteredData = {
          ...FilteredData,
          Split: {
            ...FilteredData.Split,
            Going: filterFlights(
              DatatoFilter.Split.Going,
              AppliedFilters,
              index,
              state.SearchResultType
            ),
          },
        };
      } else if (index === 3) {
        filteredData = {
          ...FilteredData,
          Split: {
            ...FilteredData.Split,
            Returning: filterFlights(
              DatatoFilter.Split.Returning,
              AppliedFilters,
              index,
              state.SearchResultType
            ),
          },
        };
      }

      dispatch(setFiltersAppliedManual(AppliedFilters));
      dispatch(setFilteredData(filteredData));
    } else if (state.SearchResultType === 5) {
      let filteredData = [];

      if (index === 0) {
        filteredData = {
          ...FilteredData,
          Row1: filterFlights(
            DatatoFilter.Row1,
            AppliedFilters,
            index,
            state.SearchResultType
          ),
        };
      } else if (index === 1) {
        filteredData = {
          ...FilteredData,
          Row2: filterFlights(
            DatatoFilter.Row2,
            AppliedFilters,
            index,
            state.SearchResultType
          ),
        };
      }

      dispatch(setFiltersAppliedManual(AppliedFilters));
      dispatch(setFilteredData(filteredData));
    } else if (state.SearchResultType === 6) {
      let filteredData = [];

      if (index < 2) {
        filteredData = {
          ...FilteredData,
          Combined: filterFlights(
            DatatoFilter.Combined,
            AppliedFilters,
            index,
            state.SearchResultType
          ),
        };
      } else if (index === 2) {
        filteredData = {
          ...FilteredData,
          Split: {
            ...FilteredData.Split,
            Row1: filterFlights(
              DatatoFilter.Split.Row1,
              AppliedFilters,
              index,
              state.SearchResultType
            ),
          },
        };
      } else if (index === 3) {
        filteredData = {
          ...FilteredData,
          Split: {
            ...FilteredData.Split,
            Row2: filterFlights(
              DatatoFilter.Split.Row2,
              AppliedFilters,
              index,
              state.SearchResultType
            ),
          },
        };
      }

      dispatch(setFiltersAppliedManual(AppliedFilters));
      dispatch(setFilteredData(filteredData));
    } else if (state.SearchResultType === 7) {
      let filteredData = [];

      if (index === 0) {
        filteredData = {
          ...FilteredData,
          Row1: filterFlights(
            DatatoFilter.Row1,
            AppliedFilters,
            index,
            state.SearchResultType
          ),
        };
      } else if (index === 1) {
        filteredData = {
          ...FilteredData,
          Row2: filterFlights(
            DatatoFilter.Row2,
            AppliedFilters,
            index,
            state.SearchResultType
          ),
        };
      } else if (index === 2) {
        filteredData = {
          ...FilteredData,
          Row3: filterFlights(
            DatatoFilter.Row3,
            AppliedFilters,
            index,
            state.SearchResultType
          ),
        };
      }

      dispatch(setFiltersAppliedManual(AppliedFilters));
      dispatch(setFilteredData(filteredData));
    } else if (state.SearchResultType === 8) {
      let filteredData = [];

      if (index < 3) {
        filteredData = {
          ...FilteredData,
          Combined: filterFlights(
            DatatoFilter.Combined,
            AppliedFilters,
            index,
            state.SearchResultType
          ),
        };
      } else if (index === 3) {
        filteredData = {
          ...FilteredData,
          Split: {
            ...FilteredData.Split,
            Row1: filterFlights(
              DatatoFilter.Split.Row1,
              AppliedFilters,
              index,
              state.SearchResultType
            ),
          },
        };
      } else if (index === 4) {
        filteredData = {
          ...FilteredData,
          Split: {
            ...FilteredData.Split,
            Row2: filterFlights(
              DatatoFilter.Split.Row2,
              AppliedFilters,
              index,
              state.SearchResultType
            ),
          },
        };
      } else if (index === 5) {
        filteredData = {
          ...FilteredData,
          Split: {
            ...FilteredData.Split,
            Row3: filterFlights(
              DatatoFilter.Split.Row3,
              AppliedFilters,
              index,
              state.SearchResultType
            ),
          },
        };
      }

      dispatch(setFiltersAppliedManual(AppliedFilters));
      dispatch(setFilteredData(filteredData));
    } else if (state.SearchResultType === 9) {
      let filteredData = [];

      if (index === 0) {
        filteredData = {
          ...FilteredData,
          Row1: filterFlights(
            DatatoFilter.Row1,
            AppliedFilters,
            index,
            state.SearchResultType
          ),
        };
      } else if (index === 1) {
        filteredData = {
          ...FilteredData,
          Row2: filterFlights(
            DatatoFilter.Row2,
            AppliedFilters,
            index,
            state.SearchResultType
          ),
        };
      } else if (index === 2) {
        filteredData = {
          ...FilteredData,
          Row3: filterFlights(
            DatatoFilter.Row3,
            AppliedFilters,
            index,
            state.SearchResultType
          ),
        };
      } else if (index === 3) {
        filteredData = {
          ...FilteredData,
          Row4: filterFlights(
            DatatoFilter.Row4,
            AppliedFilters,
            index,
            state.SearchResultType
          ),
        };
      }

      dispatch(setFiltersAppliedManual(AppliedFilters));
      dispatch(setFilteredData(filteredData));
    } else if (state.SearchResultType === 10) {
      let filteredData = [];

      if (index < 4) {
        filteredData = {
          ...FilteredData,
          Combined: filterFlights(
            DatatoFilter.Combined,
            AppliedFilters,
            index,
            state.SearchResultType
          ),
        };
      } else if (index === 4) {
        filteredData = {
          ...FilteredData,
          Split: {
            ...FilteredData.Split,
            Row1: filterFlights(
              DatatoFilter.Split.Row1,
              AppliedFilters,
              index,
              state.SearchResultType
            ),
          },
        };
      } else if (index === 5) {
        filteredData = {
          ...FilteredData,
          Split: {
            ...FilteredData.Split,
            Row2: filterFlights(
              DatatoFilter.Split.Row2,
              AppliedFilters,
              index,
              state.SearchResultType
            ),
          },
        };
      } else if (index === 6) {
        filteredData = {
          ...FilteredData,
          Split: {
            ...FilteredData.Split,
            Row3: filterFlights(
              DatatoFilter.Split.Row3,
              AppliedFilters,
              index,
              state.SearchResultType
            ),
          },
        };
      } else if (index === 7) {
        filteredData = {
          ...FilteredData,
          Split: {
            ...FilteredData.Split,
            Row4: filterFlights(
              DatatoFilter.Split.Row4,
              AppliedFilters,
              index,
              state.SearchResultType
            ),
          },
        };
      }

      dispatch(setFiltersAppliedManual(AppliedFilters));
      dispatch(setFilteredData(filteredData));
    }
  };
};

export const generateFiltersAsync = () => {
  return async (dispatch, getState) => {
    const statesData = getState();
    console.log("statesData is : ", statesData);
    let { ResultPageFlightsFlight } = statesData;

    let state = ResultPageFlightsFlight;
    console.log("the states are  : ", state);

    if (state.SearchResultType === 1 || state.SearchResultType === 2) {
      let AllFilters = [
        {
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: [],
        },
      ];

      let Journey = [
        state.SearchParameters.Segments[0].Origin,
        state.SearchParameters.Segments[0].Destination,
      ];

      let Fulldata = state.SearchResults.Data;
      let Logos = state.SearchResults.AirlinesLogos;

      await gerateFiltersParams(AllFilters, Fulldata, Logos, 0, Journey);

      dispatch(setFiltersFinalUpdate(AllFilters));
    } else if (state.SearchResultType === 3 || state.SearchResultType === 5) {
      let AllFilters = [
        {
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
        {
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
      ];

      let Logos = state.SearchResults.AirlinesLogos;

      let Journey1 = [
        state.SearchParameters.Segments[0].Origin,
        state.SearchParameters.Segments[0].Destination,
      ];

      let Row1 =
        state.SearchResultType === 3
          ? state.SearchResults.Data.Going
          : state.SearchResults.Data.Row1;

      await gerateFiltersParams(AllFilters, Row1, Logos, 0, Journey1);

      let Journey2 = [
        state.SearchResultType === 3
          ? state.SearchParameters.Segments[0].Destination
          : state.SearchParameters.Segments[1].Origin,
        state.SearchResultType === 3
          ? state.SearchParameters.Segments[0].Origin
          : state.SearchParameters.Segments[1].Destination,
      ];

      let Row2 =
        state.SearchResultType === 3
          ? state.SearchResults.Data.Returning
          : state.SearchResults.Data.Row2;

      await gerateFiltersParams(AllFilters, Row2, Logos, 1, Journey2);

      dispatch(setFiltersFinalUpdate(AllFilters));
    } else if (state.SearchResultType === 7) {
      let AllFilters = [
        {
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
        {
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
        {
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
      ];

      let Logos = state.SearchResults.AirlinesLogos;

      let Journey1 = [
        state.SearchParameters.Segments[0].Origin,
        state.SearchParameters.Segments[0].Destination,
      ];

      let Row1 = state.SearchResults.Data.Row1;

      gerateFiltersParams(AllFilters, Row1, Logos, 0, Journey1);

      let Journey2 = [
        state.SearchParameters.Segments[1].Origin,
        state.SearchParameters.Segments[1].Destination,
      ];

      let Row2 = state.SearchResults.Data.Row2;

      gerateFiltersParams(AllFilters, Row2, Logos, 1, Journey2);

      let Journey3 = [
        state.SearchParameters.Segments[2].Origin,
        state.SearchParameters.Segments[2].Destination,
      ];

      let Row3 = state.SearchResults.Data.Row3;

      gerateFiltersParams(AllFilters, Row3, Logos, 2, Journey3);

      dispatch(setFiltersFinalUpdate(AllFilters));
    } else if (state.SearchResultType === 9) {
      let AllFilters = [
        {
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
        {
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
        {
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
        {
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
      ];

      let Logos = state.SearchResults.AirlinesLogos;

      let Journey1 = [
        state.SearchParameters.Segments[0].Origin,
        state.SearchParameters.Segments[0].Destination,
      ];

      let Row1 = state.SearchResults.Data.Row1;

      await gerateFiltersParams(AllFilters, Row1, Logos, 0, Journey1);

      let Journey2 = [
        state.SearchParameters.Segments[1].Origin,
        state.SearchParameters.Segments[1].Destination,
      ];

      let Row2 = state.SearchResults.Data.Row2;

      await gerateFiltersParams(AllFilters, Row2, Logos, 1, Journey2);

      let Journey3 = [
        state.SearchParameters.Segments[2].Origin,
        state.SearchParameters.Segments[2].Destination,
      ];

      let Row3 = state.SearchResults.Data.Row3;

      await gerateFiltersParams(AllFilters, Row3, Logos, 2, Journey3);

      let Journey4 = [
        state.SearchParameters.Segments[3].Origin,
        state.SearchParameters.Segments[3].Destination,
      ];

      let Row4 = state.SearchResults.Data.Row4;

      await gerateFiltersParams(AllFilters, Row4, Logos, 3, Journey4);

      dispatch(setFiltersFinalUpdate(AllFilters));
    } else if (state.SearchResultType === 4) {
      let AllFilters = [
        {
          index: 0,
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
        {
          index: 0,
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
        {
          index: 0,
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
        {
          index: 0,
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
      ];

      let Logos = state.SearchResults.AirlinesLogos;

      // Generate for Split View
      let Journey1 = [
        state.SearchParameters.Segments[0].Origin,
        state.SearchParameters.Segments[0].Destination,
      ];

      let Row1 = state.SearchResults.Data.Split.Going;

      await gerateFiltersParams(AllFilters, Row1, Logos, 2, Journey1);

      let Journey2 = [
        state.SearchParameters.Segments[0].Destination,
        state.SearchParameters.Segments[0].Origin,
      ];

      let Row2 = state.SearchResults.Data.Split.Returning;

      await gerateFiltersParams(AllFilters, Row2, Logos, 3, Journey2);

      // Generate for Combined View
      let CombinedData = state.SearchResults.Data.Combined;

      let Journey3 = [
        {
          SeqNo: 0,
          Origin: state.SearchParameters.Segments[0].Origin,
          Destination: state.SearchParameters.Segments[0].Destination,
        },
        {
          SeqNo: 1,
          Origin: state.SearchParameters.Segments[0].Destinationm,
          Destination: state.SearchParameters.Segments[0].Origin,
        },
      ];

      await gerateFiltersParamsCombined(
        AllFilters,
        CombinedData,
        Logos,
        Journey3,
        2
      );

      dispatch(setFiltersFinalUpdate(AllFilters));
    } else if (state.SearchResultType === 6) {
      let AllFilters = [
        {
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
        {
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
        {
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
        {
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
      ];

      let Logos = state.SearchResults.AirlinesLogos;

      // Generate for Combined View
      let CombinedData = state.SearchResults.Data.Combined;

      let Journey3 = [
        {
          SeqNo: 0,
          Origin: state.SearchParameters.Segments[0].Origin,
          Destination: state.SearchParameters.Segments[0].Destination,
        },
        {
          SeqNo: 1,
          Destination: state.SearchParameters.Segments[1].Origin,
          Origin: state.SearchParameters.Segments[1].Destinationm,
        },
      ];

      await gerateFiltersParamsCombined(
        AllFilters,
        CombinedData,
        Logos,
        Journey3,
        2
      );

      // Generate for Split View
      let Journey1 = [
        state.SearchParameters.Segments[0].Origin,
        state.SearchParameters.Segments[0].Destination,
      ];

      let Row1 = state.SearchResults.Data.Split.Row1;

      await gerateFiltersParams(AllFilters, Row1, Logos, 2, Journey1);

      let Journey2 = [
        state.SearchParameters.Segments[1].Origin,
        state.SearchParameters.Segments[1].Destination,
      ];

      let Row2 = state.SearchResults.Data.Split.Row2;

      await gerateFiltersParams(AllFilters, Row2, Logos, 3, Journey2);

      dispatch(setFiltersFinalUpdate(AllFilters));
    } else if (state.SearchResultType === 8) {
      let AllFilters = [
        {
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
        {
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
        {
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
        {
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
        {
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
        {
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
      ];

      let Logos = state.SearchResults.AirlinesLogos;

      // Generate for Combined View
      let CombinedData = state.SearchResults.Data.Combined;

      let Journey4 = [
        {
          SeqNo: 0,
          Origin: state.SearchParameters.Segments[0].Origin,
          Destination: state.SearchParameters.Segments[0].Destination,
        },
        {
          SeqNo: 1,
          Destination: state.SearchParameters.Segments[1].Origin,
          Origin: state.SearchParameters.Segments[1].Destinationm,
        },
        {
          SeqNo: 2,
          Destination: state.SearchParameters.Segments[2].Origin,
          Origin: state.SearchParameters.Segments[2].Destinationm,
        },
      ];

      await gerateFiltersParamsCombined(
        AllFilters,
        CombinedData,
        Logos,
        Journey4,
        3
      );

      // Generate for Split View
      let Journey1 = [
        state.SearchParameters.Segments[0].Origin,
        state.SearchParameters.Segments[0].Destination,
      ];

      let Row1 = state.SearchResults.Data.Split.Row1;

      await gerateFiltersParams(AllFilters, Row1, Logos, 3, Journey1);

      let Journey2 = [
        state.SearchParameters.Segments[1].Origin,
        state.SearchParameters.Segments[1].Destination,
      ];

      let Row2 = state.SearchResults.Data.Split.Row2;

      await gerateFiltersParams(AllFilters, Row2, Logos, 4, Journey2);

      let Journey3 = [
        state.SearchParameters.Segments[2].Origin,
        state.SearchParameters.Segments[2].Destination,
      ];

      let Row3 = state.SearchResults.Data.Split.Row3;

      await gerateFiltersParams(AllFilters, Row3, Logos, 5, Journey3);

      dispatch(setFiltersFinalUpdate(AllFilters));
    } else if (state.SearchResultType === 10) {
      let AllFilters = [
        {
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
        {
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
        {
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
        {
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
        {
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
        {
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
        {
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
        {
          PopularFilters: [], // Initialize PopularFilters as an empty object
          PriceDragger: {},
          DurationDragger: {},
          LayoverDurationDragger: {},
          LayoverAirports: {},
          nearbyArrivalAirports: {},
          Airlines: {},
        },
      ];

      let Logos = state.SearchResults.AirlinesLogos;

      // Generate for Combined View
      let CombinedData = state.SearchResults.Data.Combined;

      let Journey5 = [
        {
          SeqNo: 0,
          Origin: state.SearchParameters.Segments[0].Origin,
          Destination: state.SearchParameters.Segments[0].Destination,
        },
        {
          SeqNo: 1,
          Destination: state.SearchParameters.Segments[1].Origin,
          Origin: state.SearchParameters.Segments[1].Destinationm,
        },
        {
          SeqNo: 2,
          Destination: state.SearchParameters.Segments[2].Origin,
          Origin: state.SearchParameters.Segments[2].Destinationm,
        },
        {
          SeqNo: 3,
          Destination: state.SearchParameters.Segments[3].Origin,
          Origin: state.SearchParameters.Segments[3].Destinationm,
        },
      ];

      await gerateFiltersParamsCombined(
        AllFilters,
        CombinedData,
        Logos,
        Journey5,
        4
      );

      // Generate for Split View
      let Journey1 = [
        state.SearchParameters.Segments[0].Origin,
        state.SearchParameters.Segments[0].Destination,
      ];

      let Row1 = state.SearchResults.Data.Split.Row1;

      await gerateFiltersParams(AllFilters, Row1, Logos, 4, Journey1);

      let Journey2 = [
        state.SearchParameters.Segments[1].Origin,
        state.SearchParameters.Segments[1].Destination,
      ];

      let Row2 = state.SearchResults.Data.Split.Row2;

      await gerateFiltersParams(AllFilters, Row2, Logos, 5, Journey2);

      let Journey3 = [
        state.SearchParameters.Segments[2].Origin,
        state.SearchParameters.Segments[2].Destination,
      ];

      let Row3 = state.SearchResults.Data.Split.Row3;

      await gerateFiltersParams(AllFilters, Row3, Logos, 6, Journey3);

      let Journey4 = [
        state.SearchParameters.Segments[3].Origin,
        state.SearchParameters.Segments[3].Destination,
      ];

      let Row4 = state.SearchResults.Data.Split.Row4;

      await gerateFiltersParams(AllFilters, Row4, Logos, 7, Journey4);

      dispatch(setFiltersFinalUpdate(AllFilters));
    }
  };
};

export const setInitialSettings = () => {
  return async (dispatch, getState) => {
    const statesData = getState();
    console.log("statesData is : ", statesData);
    let { ResultPageFlightsFlight } = statesData;

    let state = { ...ResultPageFlightsFlight };
    console.log("the states are  : ", state);

    if (state.SearchResultType === 1 || state.SearchResultType === 2) {
      let dd = await sortByPrice(state.FilteredData, 1);
      console.log("price sorted by price ios : ", dd);
      dispatch(setFilteredData(dd));
    } else if (state.SearchResultType === 3) {
      let Going = await sortByPrice(state.FilteredData.Going, 2);
      let Returning = await sortByPrice(state.FilteredData.Returning, 2);

      let DatatoPass = {
        Going: Going,
        Returning: Returning,
      };

      dispatch(setFilteredData(DatatoPass));

      let allAirlines1 = getAllAirlinesWithindex1(
        Going[0],
        1,
        state.SearchResults.AirlinesLogos,
        1
      );
      let allAirlines2 = getAllAirlinesWithindex1(
        Returning[0],
        1,
        state.SearchResults.AirlinesLogos,
        1
      );

      let Data1 = { ...Going[0], AirlinesDetails: allAirlines1 };
      let Data2 = { ...Returning[0], AirlinesDetails: allAirlines2 };

      let DatToInert = [Data1, Data2, [], []];

      dispatch(setbarModeDataInitial(DatToInert));
    } else if (state.SearchResultType === 4 && state.ResultView === 1) {
      let Combined = await sortByPrice(state.FilteredData.Combined, 2);

      let DatatoPass = {
        Split: {
          Going: state.FilteredData.Split.Going,
          Returning: state.FilteredData.Split.Returning,
        },
        Combined: Combined,
      };

      dispatch(setFilteredData(DatatoPass));
    } else if (state.SearchResultType === 4 && state.ResultView === 2) {
      let Going = await sortByPrice(state.FilteredData.Split.Going, 2);
      let Returning = await sortByPrice(state.FilteredData.Split.Returning, 2);

      console.log("Going the data is is : ", Going);
      console.log("Returning the data is is : ", Returning);
      let DatatoPass = {
        Split: { Going: Going, Returning: Returning },
        Combined: state.FilteredData.Combined,
      };

      dispatch(setFilteredData(DatatoPass));

      let allAirlines1 = getAllAirlinesWithindex1(
        Going[0],
        1,
        state.SearchResults.AirlinesLogos,
        1
      );
      let allAirlines2 = getAllAirlinesWithindex1(
        Returning[0],
        1,
        state.SearchResults.AirlinesLogos,
        1
      );

      let Data1 = { ...Going[0], AirlinesDetails: allAirlines1 };
      let Data2 = { ...Returning[0], AirlinesDetails: allAirlines2 };

      let DatToInert = [Data1, Data2, [], []];

      dispatch(setbarModeDataInitial(DatToInert));
    } else if (state.SearchResultType === 5) {
      let Row1 = await sortByPrice(state.FilteredData.Row1, 2);
      let Row2 = await sortByPrice(state.FilteredData.Row2, 2);

      let DatatoPass = {
        Row1: Row1,
        Row2: Row2,
      };

      dispatch(setFilteredData(DatatoPass));

      let allAirlines1 = getAllAirlinesWithindex1(
        Row1,
        1,
        state.SearchResults.AirlinesLogos,
        1
      );
      let allAirlines2 = getAllAirlinesWithindex1(
        Row2,
        1,
        state.SearchResults.AirlinesLogos,
        1
      );

      let Data1 = {
        ...state.FilteredData.Row1[0],
        AirlinesDetails: allAirlines1,
      };
      let Data2 = {
        ...state.FilteredData.Row2[0],
        AirlinesDetails: allAirlines2,
      };

      let DatToInert = [Data1, Data2, [], []];

      dispatch(setbarModeDataInitial(DatToInert));
    } else if (state.SearchResultType === 7) {
      let Row1 = await sortByPrice(state.FilteredData.Row1, 2);
      let Row2 = await sortByPrice(state.FilteredData.Row2, 2);
      let Row3 = await sortByPrice(state.FilteredData.Row3, 2);

      let DatatoPass = {
        Row1: Row1,
        Row2: Row2,
        Row3: Row3,
      };

      dispatch(setFilteredData(DatatoPass));

      let allAirlines1 = getAllAirlinesWithindex1(
        Row1,
        1,
        state.SearchResults.AirlinesLogos,
        1
      );
      let allAirlines2 = getAllAirlinesWithindex1(
        Row2,
        1,
        state.SearchResults.AirlinesLogos,
        1
      );
      let allAirlines3 = getAllAirlinesWithindex1(
        Row3,
        1,
        state.SearchResults.AirlinesLogos,
        1
      );

      let Data1 = { ...Row1[0], AirlinesDetails: allAirlines1 };
      let Data2 = { ...Row2[0], AirlinesDetails: allAirlines2 };
      let Data3 = { ...Row3[0], AirlinesDetails: allAirlines3 };

      let DatToInert = [Data1, Data2, Data3, []];

      dispatch(setbarModeDataInitial(DatToInert));
    } else if (state.SearchResultType === 9) {
      let Row1 = await sortByPrice(state.FilteredData.Row1, 2);
      let Row2 = await sortByPrice(state.FilteredData.Row2, 2);
      let Row3 = await sortByPrice(state.FilteredData.Row3, 2);
      let Row4 = await sortByPrice(state.FilteredData.Row4, 2);

      let DatatoPass = {
        Row1: Row1,
        Row2: Row2,
        Row3: Row3,
        Row4: Row4,
      };

      dispatch(setFilteredData(DatatoPass));

      let allAirlines1 = getAllAirlinesWithindex1(
        Row1,
        1,
        state.SearchResults.AirlinesLogos,
        1
      );
      let allAirlines2 = getAllAirlinesWithindex1(
        Row2,
        1,
        state.SearchResults.AirlinesLogos,
        1
      );
      let allAirlines3 = getAllAirlinesWithindex1(
        Row3,
        1,
        state.SearchResults.AirlinesLogos,
        1
      );
      let allAirlines4 = getAllAirlinesWithindex1(
        Row4,
        1,
        state.SearchResults.AirlinesLogos,
        1
      );

      let Data1 = { ...Row1[0], AirlinesDetails: allAirlines1 };
      let Data2 = { ...Row2[0], AirlinesDetails: allAirlines2 };
      let Data3 = { ...Row3[0], AirlinesDetails: allAirlines3 };
      let Data4 = { ...Row4[0], AirlinesDetails: allAirlines4 };

      let DatToInert = [Data1, Data2, Data3, Data4];

      dispatch(setbarModeDataInitial(DatToInert));
    } else if (state.SearchResultType === 6 && state.ResultView === 1) {
      let Combined = await sortByPrice(state.FilteredData.Combined, 1);

      let DatatoPass = {
        Split: {
          Row1: state.FilteredData.Split.Row1,
          Row2: state.FilteredData.Split.Row2,
        },
        Combined: Combined,
      };

      dispatch(setFilteredData(DatatoPass));
    } else if (state.SearchResultType === 6 && state.ResultView === 2) {
      let Row1 = await sortByPrice(state.FilteredData.Split.Row1, 2);
      let Row2 = await sortByPrice(state.FilteredData.Split.Row2, 2);

      let DatatoPass = {
        Split: { Row1: Row1, Row2: Row2 },
        Combined: state.FilteredData.Combined,
      };

      dispatch(setFilteredData(DatatoPass));

      let allAirlines1 = getAllAirlinesWithindex1(
        Row1[0],
        1,
        state.SearchResults.AirlinesLogos,
        1
      );
      let allAirlines2 = getAllAirlinesWithindex1(
        Row2[0],
        1,
        state.SearchResults.AirlinesLogos,
        1
      );

      let Data1 = { ...Row1[0], AirlinesDetails: allAirlines1 };
      let Data2 = { ...Row2[0], AirlinesDetails: allAirlines2 };

      let DatToInert = [Data1, Data2, [], []];

      dispatch(setbarModeDataInitial(DatToInert));
    } else if (state.SearchResultType === 8 && state.ResultView === 1) {
      let Combined = await sortByPrice(state.FilteredData.Combined, 1);

      let DatatoPass = {
        Split: {
          Row1: state.FilteredData.Split.Row1,
          Row2: state.FilteredData.Split.Row2,
          Row3: state.FilteredData.Split.Row3,
        },
        Combined: Combined,
      };

      dispatch(setFilteredData(DatatoPass));
    } else if (state.SearchResultType === 8 && state.ResultView === 2) {
      let Row1 = await sortByPrice(state.FilteredData.Split.Row1, 2);
      let Row2 = await sortByPrice(state.FilteredData.Split.Row2, 2);
      let Row3 = await sortByPrice(state.FilteredData.Split.Row3, 2);

      let DatatoPass = {
        Split: { Row1: Row1, Row2: Row2, Row3: Row3 },
        Combined: state.FilteredData.Combined,
      };

      dispatch(setFilteredData(DatatoPass));

      let allAirlines1 = getAllAirlinesWithindex1(
        Row1[0],
        1,
        state.SearchResults.AirlinesLogos,
        1
      );
      let allAirlines2 = getAllAirlinesWithindex1(
        Row2[0],
        1,
        state.SearchResults.AirlinesLogos,
        1
      );
      let allAirlines3 = getAllAirlinesWithindex1(
        Row3[0],
        1,
        state.SearchResults.AirlinesLogos,
        1
      );

      let Data1 = { ...Row1[0], AirlinesDetails: allAirlines1 };
      let Data2 = { ...Row2[0], AirlinesDetails: allAirlines2 };
      let Data3 = { ...Row3[0], AirlinesDetails: allAirlines3 };

      let DatToInert = [Data1, Data2, Data3, []];

      dispatch(setbarModeDataInitial(DatToInert));
    } else if (state.SearchResultType === 10 && state.ResultView === 1) {
      let Combined = await sortByPrice(state.FilteredData.Combined, 1);

      let DatatoPass = {
        Split: {
          Row1: state.FilteredData.Split.Row1,
          Row2: state.FilteredData.Split.Row2,
          Row3: state.FilteredData.Split.Row3,
          Row4: state.FilteredData.Split.Row4,
        },
        Combined: Combined,
      };

      dispatch(setFilteredData(DatatoPass));
    } else if (state.SearchResultType === 10 && state.ResultView === 2) {
      let Row1 = await sortByPrice(state.FilteredData.Split.Row1, 2);
      let Row2 = await sortByPrice(state.FilteredData.Split.Row2, 2);
      let Row3 = await sortByPrice(state.FilteredData.Split.Row3, 2);
      let Row4 = await sortByPrice(state.FilteredData.Split.Row4, 2);

      let DatatoPass = {
        Split: { Row1: Row1, Row2: Row2, Row3: Row3, Row4: Row4 },
        Combined: state.FilteredData.Combined,
      };

      dispatch(setFilteredData(DatatoPass));

      let allAirlines1 = getAllAirlinesWithindex1(
        Row1[0],
        1,
        state.SearchResults.AirlinesLogos,
        1
      );
      let allAirlines2 = getAllAirlinesWithindex1(
        Row2[0],
        1,
        state.SearchResults.AirlinesLogos,
        1
      );
      let allAirlines3 = getAllAirlinesWithindex1(
        Row3[0],
        1,
        state.SearchResults.AirlinesLogos,
        1
      );
      let allAirlines4 = getAllAirlinesWithindex1(
        Row4[0],
        1,
        state.SearchResults.AirlinesLogos,
        1
      );

      let Data1 = { ...Row1[0], AirlinesDetails: allAirlines1 };
      let Data2 = { ...Row2[0], AirlinesDetails: allAirlines2 };
      let Data3 = { ...Row3[0], AirlinesDetails: allAirlines3 };
      let Data4 = { ...Row4[0], AirlinesDetails: allAirlines4 };

      let DatToInert = [Data1, Data2, Data3, Data4];

      dispatch(setbarModeDataInitial(DatToInert));
    }
  };
};

export const ReviewPageRedirector = (Data, navigate, Theme) => {
  return async (dispatch, getState) => {
    const statesData = getState();

    let { ResultPageFlightsFlight } = statesData;

    let state = { ...ResultPageFlightsFlight };

    let apiParams = {};

    console.log("The selected Data for the revioew is  : ", Data);

    if (state.SearchResultType === 1 || state.SearchResultType === 2) {
      console.log("the dtaa ot book is : ", Data);

      switch (Data.DataFormat) {
        case "DOM-OW":
          // Reduced to just DataFormat + ResultId — per explicit instruction ("bus ResultId hi
          // bhejo hold pe, baaki ke params us saved data se banao, security wise behtar
          // rahega"). NOTE: this ResultId is NOT the raw TBO ResultIndex token — the backend's
          // own anonymizeResultIds() already overwrote it with a small per-response sequential
          // counter before this ever reached the frontend (so the real token never left the
          // backend at all, an even better security property than originally assumed here) — a
          // far more robust match key server-side than the earlier FlightNumbers-based attempt
          // (which could in theory collide on codeshares/duplicate flight numbers) regardless,
          // and sends essentially nothing about the actual flight itself. DataFormat stays
          // (checkParamsValidity() still needs it to know which module this is); everything else
          // (Company/CompanyType/ApiSource/FlightNumbers) is reconstructed server-side by
          // holdTheFlight(), matched against the already-saved FlightSearchResult row's own
          // '_AnonResultId' tag (see tagAnonymizedResultIds()/reconstructParamsFromSavedSearchResult()).
          // ResultSetId (the saved row's own DB id, from the search response — see
          // onewayDomesticHandler()'s own comment) is what holdTheFlight() actually looks the row
          // up by now, not SearchId — found via explicit trace that a SearchId+JSON-array lookup,
          // while not actually ambiguous, meant a full table scan on every Hold; a row's own
          // primary key is instant and unambiguous. SearchId stays too — still needed for
          // ownership (user_id/admin_id) via the original FlightSearch row, a separate concern.
          apiParams = {
            SearchId: state.SearchResults.SearchId,
            ResultSetId: state.SearchResults.ResultSetId,
            Mode: "fr",
            FunctionType: "Oneway Domestic",
            Params: [
              {
                DataFormat: "DOM-OW",
                ResultId: Data?.ResultId,
              },
            ],
            FFIndexes: [state.FFSelected[0]],
          };

          break;
        case "DOM-OW-NR":
          // Migrated to the same DataFormat+ResultId-only pattern as DOM-OW/DOM-OW-CA — per
          // explicit instruction ("hamesha jo data save kia hai ussi se banao aage ke parametrs
          // hold ke liye", i.e. never trust the client for this, always rebuild from the saved
          // FlightSearchResult row). Company/CompanyType/ApiSource/NearestAirport/
          // NearestAirportData/FlightNumbers are all reconstructed server-side by holdTheFlight()
          // now — DOM-OW-NR's saved item already carries its own NearestAirportData (stamped by
          // onewayDataFormatter() at search time, same as every other field), so
          // reconstructParamsFromSavedSearchResult() needed no NEW backend lookup mechanism, only
          // reading one more field off the already-matched node (see that function's own
          // docblock).
          apiParams = {
            SearchId: state.SearchResults.SearchId,
            ResultSetId: state.SearchResults.ResultSetId,
            Mode: "fr",
            FunctionType: "Oneway Domestic",
            Params: [
              {
                DataFormat: "DOM-OW-NR",
                ResultId: Data?.ResultId,
              },
            ],
            FFIndexes: [state.FFSelected[0]],
          };

          break;
        case "DOM-OW-CA":
          // Reduced to DataFormat + ResultId (+ the two fields holdTheFlight() can't derive from
          // the saved search data alone: ConnectingAirport/DepartureDate, which aren't part of
          // the saved item's identifying info, they're hold-call parameters in their own right)
          // — per the same "bus ResultId hi bhejo, baaki saved data se banao" instruction already
          // applied to DOM-OW. Each connection has its OWN ResultId (Data.Connections[i].ResultId
          // — already the anonymized per-item id the backend handed back, same as every other
          // module), so each gets its own Params entry exactly as before, just stripped down.
          // Company/CompanyType/ApiSource/FlightNumbers are reconstructed server-side by
          // holdTheFlight(), matched against the saved FlightSearchResult row's nested
          // Connections[0]/[1] by that same ResultId (see reconstructParamsFromSavedSearchResult()'s
          // own docblock for how a CA item's nested-node shape is handled). ResultSetId — see
          // the DOM-OW case above's own comment for why this replaced SearchId as the actual
          // lookup key (SearchId stays too, for ownership).
          apiParams = {
            SearchId: state.SearchResults.SearchId,
            ResultSetId: state.SearchResults.ResultSetId,
            Mode: "fr",
            FunctionType: "Oneway Domestic",
            Params: [
              {
                DataFormat: "DOM-OW-CA",
                ResultId: Data?.Connections[0]?.ResultId,
                ConnectingAirport:
                  Data.Connections[0].Segments[
                    Data.Connections[0].Segments.length - 1
                  ].Destination.Airport.AirportCode,
                DepartureDate: Data.Connections[0].Segments[0].Origin.DepTime,
              },

              {
                DataFormat: "DOM-OW-CA",
                ResultId: Data?.Connections[1]?.ResultId,
                DepartureDate: Data.Connections[1].Segments[0].Origin.DepTime,
              },
            ],
            FFIndexes: [
              state.FFSelected[0],
              state.FFSelected[1],
            ],
          };

          break;
        case "INT-OW":
          // Migrated to the same DataFormat+ResultId-only pattern as DOM-OW ("jab main kahunga
          // tab INT-OW/INT-OW-NR/INT-OW-VIA ke liye bhi kar doge?" — this is that). Company/
          // CompanyType/ApiSource/FlightNumbers reconstructed server-side by holdTheFlight() from
          // the already-saved FlightSearchResult row.
          apiParams = {
            SearchId: state.SearchResults.SearchId,
            ResultSetId: state.SearchResults.ResultSetId,
            Mode: "fr",
            FunctionType: "Oneway International",
            Params: [
              {
                DataFormat: "INT-OW",
                ResultId: Data?.ResultId,
              },
            ],
            FFIndexes: [state.FFSelected[0]],
          };

          break;
        case "INT-OW-NR":
          // Same migration as DOM-OW-NR — NearestAirport/NearestAirportData also reconstructed
          // server-side now (saved item already carries NearestAirportData, same as DOM-OW-NR's
          // own).
          apiParams = {
            SearchId: state.SearchResults.SearchId,
            ResultSetId: state.SearchResults.ResultSetId,
            Mode: "fr",
            FunctionType: "Oneway International",
            Params: [
              {
                DataFormat: "INT-OW-NR",
                ResultId: Data?.ResultId,
              },
            ],
            FFIndexes: [state.FFSelected[0]],
          };

          break;
        case "INT-OW-VIA":
          // Same pattern — ViaAirports also reconstructed server-side (saved item already
          // carries it, stamped by the formatter at search time, same as NearestAirportData).
          apiParams = {
            SearchId: state.SearchResults.SearchId,
            ResultSetId: state.SearchResults.ResultSetId,
            Mode: "fr",
            FunctionType: "Oneway International",
            Params: [
              {
                DataFormat: "INT-OW-VIA",
                ResultId: Data?.ResultId,
              },
            ],
            FFIndexes: [state.FFSelected[0]],
          };

          break;
        case "INT-OW-CA":
          // Same migration as DOM-OW-CA — ConnectingAirport/DepartureDate stay client-side (genuine
          // hold parameters, not identifying info the server can derive); Company/CompanyType/
          // ApiSource/FlightNumbers reconstructed per-connection from the saved row.
          apiParams = {
            SearchId: state.SearchResults.SearchId,
            ResultSetId: state.SearchResults.ResultSetId,
            Mode: "fr",
            FunctionType: "Oneway International",
            Params: [
              {
                DataFormat: "INT-OW-CA",
                ResultId: Data?.Connections[0]?.ResultId,
                ConnectingAirport:
                  Data.Connections[0].Segments[
                    Data.Connections[0].Segments.length - 1
                  ].Destination.Airport.AirportCode,
                DepartureDate: Data.Connections[0].Segments[0].Origin.DepTime,
              },

              {
                DataFormat: "INT-OW-CA",
                ResultId: Data?.Connections[1]?.ResultId,
                DepartureDate: Data.Connections[1].Segments[0].Origin.DepTime,
              },
            ],
            FFIndexes: [
              state.FFSelected[0],
              state.FFSelected[1],
            ],
          };

          break;

        default:
          break;
      }
    } else if (state.SearchResultType === 3) {
      // Migrated to DataFormat+ResultId-only — per explicit instruction ("round domestic mein
      // bhi yeh sab cheezein karo"). Data[0]/Data[1] are the independently-picked Going/Returning
      // items (each already carrying its own anonymized ResultId, same as any flat DOM-OW/
      // DOM-OW-NR item) — Company/CompanyType/ApiSource/FlightNumbers/NearestAirport*
      // (DOM-RD-NR only) all reconstructed server-side by holdTheFlight(), same generic
      // reconstructParamsFromSavedSearchResult() every other migrated module already uses.
      apiParams = {
        SearchId: state.SearchResults.SearchId,
        ResultSetId: state.SearchResults.ResultSetId,
        Mode: "fr",
        FunctionType: "Round Domestic",
        Params: [
          {
            DataFormat: Data[0].DataFormat == "DOM-RD" ? "DOM-RD" : "DOM-RD-NR",
            ResultId: Data[0]?.ResultId,
          },
          {
            DataFormat: Data[1].DataFormat == "DOM-RD" ? "DOM-RD" : "DOM-RD-NR",
            ResultId: Data[1]?.ResultId,
          },
        ],
        FFIndexes: [
          state.FFSelected[0],
          state.FFSelected[1],
        ],
      };
    } else if (state.SearchResultType === 4 && state.ResultView === 1) {
      switch (Data.DataFormat) {
        case "INT-RD":
          // Migrated to DataFormat+ResultId-only — per explicit instruction ("round domestic
          // mein bhi yeh sab cheezein karo" / "jab main kahunga... bhi kar doge?" — this is
          // that, for Round International). Company/CompanyType/ApiSource/FlightNumbers
          // reconstructed server-side by holdTheFlight() from the saved FlightSearchResult row.
          apiParams = {
            SearchId: state.SearchResults.SearchId,
            ResultSetId: state.SearchResults.ResultSetId,
            Mode: "fr",
            FunctionType: "Roundway International",
            Params: [
              {
                DataFormat: "INT-RD",
                ResultId: Data?.ResultId,
              },
            ],
            FFIndexes: [state.FFSelected[0]],
          };
          break;
        case "INT-RD-NR":
          // Same migration — NearestAirport/NearestAirportData also reconstructed server-side
          // now (saved item already carries NearestAirportData, same as every other *-NR item).
          apiParams = {
            SearchId: state.SearchResults.SearchId,
            ResultSetId: state.SearchResults.ResultSetId,
            Mode: "fr",
            FunctionType: "Roundway International",
            Params: [
              {
                DataFormat: "INT-RD-NR",
                ResultId: Data?.ResultId,
              },
            ],
            FFIndexes: [state.FFSelected[0]],
          };
          break;
        case "INT-RD-OWOW":
          // Same migration — each connection sends only its own ResultId; whether it was
          // genuinely a nearest-airport leg or not no longer needs deciding client-side at all
          // (that NearestAirport* reconstruction, like everywhere else, happens server-side from
          // the saved node only when that node actually carries it).
          apiParams = {
            SearchId: state.SearchResults.SearchId,
            ResultSetId: state.SearchResults.ResultSetId,
            Mode: "fr",
            FunctionType: "Roundway International",
            Params: [
              {
                DataFormat: "INT-RD-OWOW",
                ResultId: Data.Connections[0]?.ResultId,
              },
              {
                DataFormat: "INT-RD-OWOW",
                ResultId: Data.Connections[1]?.ResultId,
              },
            ],
            FFIndexes: [
              state.FFSelected[0],
              state.FFSelected[1],
            ],
          };
          break;
        default:
          break;
      }
    } else if (state.SearchResultType === 4 && state.ResultView === 2) {
      // Same migration as the INT-RD-OWOW case above, just reached via the Split
      // ("Select Your Own Flights") pair — Data[0]/Data[1] instead of Data.Connections[0]/[1].
      apiParams = {
        SearchId: state.SearchResults.SearchId,
        ResultSetId: state.SearchResults.ResultSetId,
        Mode: "fr",
        FunctionType: "Roundway International",
        Params: [
          {
            DataFormat: "INT-RD-OWOW",
            ResultId: Data[0]?.ResultId,
          },
          {
            DataFormat: "INT-RD-OWOW",
            ResultId: Data[1]?.ResultId,
          },
        ],
        FFIndexes: [
          state.FFSelected[0],
          state.FFSelected[1],
        ],
      };
    } else if (state.SearchResultType === 5) {
      // Migrated to DataFormat+ResultId-only — per explicit instruction ("isi tarha ke sab
      // changes multi domestic mein bhi karo"). The DOM-ML-{row}/DOM-ML-NR-{row} branch no longer
      // needs deciding client-side at all (NearestAirport* reconstructs server-side only when the
      // matched saved node actually carries it, same as every other migrated *-NR module) — each
      // row just sends whichever DataFormat it already has, plus its own ResultId.
      apiParams = {
        SearchId: state.SearchResults.SearchId,
        ResultSetId: state.SearchResults.ResultSetId,
        Mode: "fr",
        FunctionType: "Multiway Domestic 2",
        Params: [
          {
            DataFormat: Data[0]?.DataFormat,
            ResultId: Data[0]?.ResultId,
          },
          {
            DataFormat: Data[1]?.DataFormat,
            ResultId: Data[1]?.ResultId,
          },
        ],
        FFIndexes: [
          state.FFSelected[0],
          state.FFSelected[1],
        ],
      };
    } else if (state.SearchResultType === 7) {
      apiParams = {
        SearchId: state.SearchResults.SearchId,
        ResultSetId: state.SearchResults.ResultSetId,
        Mode: "fr",
        FunctionType: "Multiway Domestic 3",
        Params: [
          {
            DataFormat: Data[0]?.DataFormat,
            ResultId: Data[0]?.ResultId,
          },
          {
            DataFormat: Data[1]?.DataFormat,
            ResultId: Data[1]?.ResultId,
          },
          {
            DataFormat: Data[2]?.DataFormat,
            ResultId: Data[2]?.ResultId,
          },
        ],
        FFIndexes: [
          state.FFSelected[0],
          state.FFSelected[1],
          state.FFSelected[2],
        ],
      };
    } else if (state.SearchResultType === 9) {
      apiParams = {
        SearchId: state.SearchResults.SearchId,
        ResultSetId: state.SearchResults.ResultSetId,
        Mode: "fr",
        FunctionType: "Multiway Domestic 4",
        Params: [
          {
            DataFormat: Data[0]?.DataFormat,
            ResultId: Data[0]?.ResultId,
          },
          {
            DataFormat: Data[1]?.DataFormat,
            ResultId: Data[1]?.ResultId,
          },
          {
            DataFormat: Data[2]?.DataFormat,
            ResultId: Data[2]?.ResultId,
          },
          {
            DataFormat: Data[3]?.DataFormat,
            ResultId: Data[3]?.ResultId,
          },
        ],
        FFIndexes: [
          state.FFSelected[0],
          state.FFSelected[1],
          state.FFSelected[2],
          state.FFSelected[3],
        ],
      };
    } else if (state.SearchResultType === 6 && state.ResultView === 1) {
      console.log("Data.DataFormat is : " , Data.DataFormat);

      // Migrated to DataFormat+ResultId-only — per explicit instruction ("isi tarha ke sab
      // changes international multi 2,3,4 mein bhi karo"). FunctionType strings stay exactly as
      // before ("Multiway International 2"/"Combined 2") — holdTheFlight() normalizes these down
      // to the canonical "Multiway International {row}" form before using them as the saved-row
      // lookup's integrity guard (see MainHoldController::normalizeFunctionTypeForSavedResultLookup()).
      switch (Data.DataFormat) {
        case "INT-ML-2":
          apiParams = {
            SearchId: state.SearchResults.SearchId,
            ResultSetId: state.SearchResults.ResultSetId,
            Mode: "fr",
            FunctionType: "Multiway International 2",
            Params: [
              {
                DataFormat: "INT-ML-2",
                ResultId: Data?.ResultId,
              },
            ],
            FFIndexes: [state.FFSelected[0]],
          };
          break;
        case "INT-ML-OWOW-2":
          apiParams = {
            SearchId: state.SearchResults.SearchId,
            ResultSetId: state.SearchResults.ResultSetId,
            Mode: "fr",
            FunctionType: "Multiway International Combined 2",
            Params: [
              {
                DataFormat: Data.Connections[0].DataFormat,
                ResultId: Data.Connections[0]?.ResultId,
              },
              {
                DataFormat: Data.Connections[1].DataFormat,
                ResultId: Data.Connections[1]?.ResultId,
              },
            ],
            FFIndexes: [
              state.FFSelected[0],
              state.FFSelected[1],
            ],
          };
          break;
        default:
          break;
      }

    } else if (state.SearchResultType === 6 && state.ResultView === 2) {
      apiParams = {
        SearchId: state.SearchResults.SearchId,
        ResultSetId: state.SearchResults.ResultSetId,
        Mode: "fr",
        FunctionType: "Multiway International Split 2",
        Params: [
          {
            DataFormat: Data[0].DataFormat,
            ResultId: Data[0]?.ResultId,
          },
          {
            DataFormat: Data[1].DataFormat,
            ResultId: Data[1]?.ResultId,
          },
        ],
        FFIndexes: [
          state.FFSelected[0],
          state.FFSelected[1],
        ],
      };
    } else if (state.SearchResultType === 8 && state.ResultView === 1) {
      switch (Data.DataFormat) {
        case "INT-ML-3":
          apiParams = {
            SearchId: state.SearchResults.SearchId,
            ResultSetId: state.SearchResults.ResultSetId,
            Mode: "fr",
            FunctionType: "Multiway International 3",
            Params: [
              {
                DataFormat: "INT-ML-3",
                ResultId: Data?.ResultId,
              },
            ],
            FFIndexes: [state.FFSelected[0]],
          };
          break;
        case "INT-ML-OWOW-3":
          apiParams = {
            SearchId: state.SearchResults.SearchId,
            ResultSetId: state.SearchResults.ResultSetId,
            Mode: "fr",
            FunctionType: "Multiway International Combined 3",
            Params: [
              {
                DataFormat: Data.Connections[0].DataFormat,
                ResultId: Data.Connections[0]?.ResultId,
              },
              {
                DataFormat: Data.Connections[1].DataFormat,
                ResultId: Data.Connections[1]?.ResultId,
              },
              {
                DataFormat: Data.Connections[2].DataFormat,
                ResultId: Data.Connections[2]?.ResultId,
              },
            ],
            FFIndexes: [
              state.FFSelected[0],
              state.FFSelected[1],
              state.FFSelected[2],
            ],
          };
          break;
        default:
          break;
      }
    } else if (state.SearchResultType === 8 && state.ResultView === 2) {
      apiParams = {
        SearchId: state.SearchResults.SearchId,
        ResultSetId: state.SearchResults.ResultSetId,
        Mode: "fr",
        FunctionType: "Multiway International Split 3",
        Params: [
          {
            DataFormat: Data[0].DataFormat,
            ResultId: Data[0]?.ResultId,
          },
          {
            DataFormat: Data[1].DataFormat,
            ResultId: Data[1]?.ResultId,
          },
          {
            DataFormat: Data[2].DataFormat,
            ResultId: Data[2]?.ResultId,
          },
        ],
        FFIndexes: [
          state.FFSelected[0],
          state.FFSelected[1],
          state.FFSelected[2],
        ],
      };
    } else if (state.SearchResultType === 10 && state.ResultView === 1) {
      switch (Data.DataFormat) {
        case "INT-ML-4":
          apiParams = {
            SearchId: state.SearchResults.SearchId,
            ResultSetId: state.SearchResults.ResultSetId,
            Mode: "fr",
            FunctionType: "Multiway International 4",
            Params: [
              {
                DataFormat: "INT-ML-4",
                ResultId: Data?.ResultId,
              },
            ],
            FFIndexes: [state.FFSelected[0]],
          };
          break;
        case "INT-ML-OWOW-4":
          apiParams = {
            SearchId: state.SearchResults.SearchId,
            ResultSetId: state.SearchResults.ResultSetId,
            Mode: "fr",
            FunctionType: "Multiway International Combined 4",
            Params: [
              {
                DataFormat: Data.Connections[0].DataFormat,
                ResultId: Data.Connections[0]?.ResultId,
              },
              {
                DataFormat: Data.Connections[1].DataFormat,
                ResultId: Data.Connections[1]?.ResultId,
              },
              {
                DataFormat: Data.Connections[2].DataFormat,
                ResultId: Data.Connections[2]?.ResultId,
              },
              {
                DataFormat: Data.Connections[3].DataFormat,
                ResultId: Data.Connections[3]?.ResultId,
              },
            ],
            FFIndexes: [
              state.FFSelected[0],
              state.FFSelected[1],
              state.FFSelected[2],
              state.FFSelected[3],
            ],
          };
          break;
        default:
          break;
      }
    } else if (state.SearchResultType === 10 && state.ResultView === 2) {
      apiParams = {
        SearchId: state.SearchResults.SearchId,
        ResultSetId: state.SearchResults.ResultSetId,
        Mode: "fr",
        FunctionType: "Multiway International Split 4",
        Params: [
          {
            DataFormat: Data[0].DataFormat,
            ResultId: Data[0]?.ResultId,
          },
          {
            DataFormat: Data[1].DataFormat,
            ResultId: Data[1]?.ResultId,
          },
          {
            DataFormat: Data[2].DataFormat,
            ResultId: Data[2]?.ResultId,
          },
          {
            DataFormat: Data[3].DataFormat,
            ResultId: Data[3]?.ResultId,
          },
        ],
        FFIndexes: [
          state.FFSelected[0],
          state.FFSelected[1],
          state.FFSelected[2],
          state.FFSelected[3],
        ],
      };
    }

    // DisplayCurrency — the currency the user actually had SELECTED at search time (Header.jsx's
    // currency dropdown, carried as &vc= on the results URL and mirrored into localStorage by the
    // same getSelectedCurrencyForUrl() the results-page re-search/URL-building code already uses
    // — see that function's own comment), NOT the pipeline/provider's own DealFareCurrency. Added
    // once here (every branch above already finished building its own apiParams) rather than in
    // each of the 20+ FunctionType branches — per explicit instruction ("jab search hoke aata hai
    // ... yeh currency code bhi hold ki api mein as parameter jaaye, and AirHoldBookings mein save
    // ho jaye"). holdTheFlight() reads this into the hold row's own 'currency_code' column.
    apiParams.DisplayCurrency = getSelectedCurrencyForUrl();

    console.log("state.SearchResultType :  ", state.SearchResultType);
    console.log("state.ResultView :  ", state.ResultView);
    console.log("thr api params ehre si  :  ", apiParams);

    try {
      let HoldParas = await HoldTheFlight(apiParams);

      dispatch(setbookLoading(false));

      let itr = HoldParas.data.ItenaryID;
      let srid = HoldParas.data.SearchId;

      // Prepare the data to be encrypted

      const dataToEncrypt = {
        Theme,
        searchkey: state.searchkey,
        itrCode: state.itrCode,
      };

      // Encrypt the object using AES encryption
      const secretKey = "your-secret-key"; // Replace with your own secret key
      const encryptedData = CryptoJS.AES.encrypt(
        JSON.stringify(dataToEncrypt),
        secretKey
      ).toString();

      // Construct the URL with the encrypted data and plain itr and srid

      const reviewDetailsLink = `${window.location.origin}/flights/review-details?itr=${itr}&sri=${srid}&dti=${encodeURIComponent(
          encryptedData
        )}`;

      console.log("the end link is : " , reviewDetailsLink);

      // TEMP DEBUGGING ONLY — shows the generated review-details link in a copyable prompt
      // instead of (also) opening it, so it can be pasted into a separate tab and inspected via
      // DevTools' Network tab for the "sell" request's real status/response. Remove this prompt()
      // call once the intermittent "Invalid Link" issue is diagnosed.
      window.prompt("Copy this review-details link (Ctrl+C, then Enter/Cancel):", reviewDetailsLink);

      window.open(reviewDetailsLink, "_blank");


    } catch (e) {
      dispatch(setbookLoading(false));
      // RES_EXPIRED (MainHoldController.php's holdTheFlight(), "fr" branch) — the saved search
      // data a ResultId-only Hold needed (DOM-OW/DOM-OW-CA's pattern) is gone, past its 10-minute
      // cache TTL — per explicit instruction, show that exact backend message instead of the
      // generic "Please Try Again" one, since "try again" is actively wrong advice here (retrying
      // the SAME hold will just fail the same way again — only a fresh search fixes it). Any other
      // error keeps the existing generic message (null => BottomBar/index.js's own default).
      dispatch(
        setbookLoadingErrorMessage(
          e?.response?.data?.code === "RES_EXPIRED"
            ? e.response.data.Message
            : null
        )
      );
      dispatch(setbookLoadingError(true));
    }

    console.log("the api params are  : ", apiParams);
  };
};

// Roundway International = 4
// Multi domestic 2 Row= 5
// Multi International 2 Row= 6
// Multi domestic 3 Row= 7
// Multi International 3 Row= 8
// Multi domestic 4 Row= 9
// Multi International 4 Row= 10

const ResultPageFlightsFlightSlice = createSlice({
  name: "ResultPageFlightsFlight",
  initialState,
  reducers: {
    // Navigating away from the results page (e.g. browser back to the homepage) should never
    // leave stale results/filters/price-range behind for the NEXT search to accidentally mix
    // with — a fresh search always starts from getUrlParams, but until that runs, anything still
    // reading this slice (filter sliders, cached min/max, etc.) would otherwise show the
    // previous search's leftover state. Returning initialState wipes it all in one go.
    resetResultPageState: () => initialState,

    // Search bar Reducers

    getUrlParams: (state, action) => {
      // Each itr segment string is "Origin-Destination-Date-OriginCC-DestCC" (e.g.
      // "DXB-LHR-16-09-2026-AE-GB"), all dash-joined with no distinct separator around the date.
      // Origin/Destination/the two trailing country codes are always fixed-width (3/3/2/2 chars),
      // but the DATE in between is NOT — a single-digit day or month ("6-09-2026", 9 chars instead
      // of "06-09-2026"'s 10) shifts every character position after it by however many digits are
      // missing. The old code read the country codes by hardcoded character offsets
      // (substring(19,21)/substring(22,25)), which silently grabbed the wrong characters whenever
      // the date wasn't exactly 10 characters — misreading country codes as e.g. "-A"/"E-" instead
      // of "AE", which could misclassify an international round-trip as domestic (wrong
      // SearchResultType -> wrong Redux branch -> "Fulldata.forEach is not a function"/
      // "filteredData is not iterable" crashes once the actual response shape didn't match what
      // that wrong branch expected).
      //
      // Splitting on "-" instead is robust to the date's digit padding either way: Origin/
      // Destination are always the first two tokens, and the two country codes are always the
      // LAST two tokens, regardless of how many tokens the date in between contributes.
      let parseItrSegment = (item) => {
        const parts = item.split("-");
        return {
          Origin: parts[0],
          Destination: parts[1],
          OriginCountryCode: parts[parts.length - 2],
          DestinationCountryCode: parts[parts.length - 1],
          Date: parts.slice(2, parts.length - 2).join("-"),
        };
      };

      let GenerateTheSegments = (itrData, params) => {
        let splitTheItr = itrData.split("|");

        // Map each segment to an object with the required fields
        let finalSegments = splitTheItr.map((item, index) => {
          const parsed = parseItrSegment(item);
          return {
            Origin: parsed.Origin,
            Destination: parsed.Destination,
            OriginCity: params[index].OriginCity,
            DestinationCity: params[index].DestinationCity,
            OriginCountryCode: parsed.OriginCountryCode,
            DestinationCountryCode: parsed.DestinationCountryCode,
            Date: parsed.Date,
          };
        });

        if (finalSegments?.length > 1) {
          state.multiRowNumber = finalSegments?.length;
        }
        return finalSegments;
      };

      // Takes ONE raw itr segment string and the switched pipeline's own region code (the URL's
      // &pid= — e.g. "AU" for an Australia pipeline, or "x"/falsy for Global mode).
      //
      // This used to just compare the segment's own two country codes against EACH OTHER
      // (Origin===Destination? "domestic" : "international") — which is NOT what the backend
      // actually does (getFunctionType() in MainSearchHelpers.php): a route only counts as
      // domestic when BOTH its Origin and Destination match the SWITCHED PIPELINE's own region,
      // not merely when they match each other. An admin searching a UAE-UAE route (Origin===
      // Destination country) while pid=AU (an Australia pipeline) is genuinely International by
      // the backend's own definition — its region ("AU") doesn't match either UAE endpoint — so
      // the backend runs roundwayInternationalHandler and returns the Split{Going,Returning}
      // shape, but the old frontend check called this same search "domestic" (SearchResultType=3)
      // purely because both endpoints happened to be the same country as each other, routing into
      // the Redux branch that reads Data.Going/Data.Row1 (fields that don't exist on this
      // response) — "Fulldata.forEach is not a function"/"filteredData is not iterable".
      //
      // Global mode (no pid, or pid==="x") has no single region to compare against — the backend
      // always treats it as International regardless of the segments' own countries, matched here
      // by returning true unconditionally in that case.
      let isInternationalTrip = (item, userRegionCode) => {
        if (!userRegionCode || userRegionCode === "x") {
          return true;
        }
        const parsed = parseItrSegment(item);
        return (
          parsed.OriginCountryCode !== userRegionCode ||
          parsed.DestinationCountryCode !== userRegionCode
        );
      };

      let getTheResultType = (itrData, userRegionCode) => {
        // Oneway domestic = 1
        // Oneway International = 2
        // Round domestic = 3
        // Roundway International = 4
        // Multi domestic 2 Row= 5
        // Multi International 2 Row= 6
        // Multi domestic 3 Row= 7
        // Multi International 3 Row= 8
        // Multi domestic 4 Row= 9
        // Multi International 4 Row= 10

        if (itrData?.length === 1) {
          let isInternational = isInternationalTrip(itrData[0], userRegionCode);

          if (isInternational === true) {
            return 2;
          }
          return 1;
        } else if (itrData?.length === 2) {
          if (
            itrData[0].substring(0, 3) === itrData[1].substring(4, 7) &&
            itrData[0].substring(4, 7) === itrData[1].substring(0, 3)
          ) {
            let isInternational =
              isInternationalTrip(itrData[0], userRegionCode) ||
              isInternationalTrip(itrData[1], userRegionCode);

            if (isInternational === true) {
              return 4;
            }
            return 3;
          } else {
            let isInternational1 = isInternationalTrip(itrData[0], userRegionCode);
            let isInternational2 = isInternationalTrip(itrData[1], userRegionCode);

            if (isInternational1 === true || isInternational2 === true) {
              return 6;
            }
            return 5;
          }
        } else if (itrData?.length === 3) {
          let isInternational1 = isInternationalTrip(itrData[0], userRegionCode);
          let isInternational2 = isInternationalTrip(itrData[1], userRegionCode);
          let isInternational3 = isInternationalTrip(itrData[2], userRegionCode);

          if (
            isInternational1 === true ||
            isInternational2 === true ||
            isInternational3 === true
          ) {
            return 8;
          }
          return 7;
        } else if (itrData?.length === 4) {
          let isInternational1 = isInternationalTrip(itrData[0], userRegionCode);
          let isInternational2 = isInternationalTrip(itrData[1], userRegionCode);
          let isInternational3 = isInternationalTrip(itrData[2], userRegionCode);
          let isInternational4 = isInternationalTrip(itrData[3], userRegionCode);

          if (
            isInternational1 === true ||
            isInternational2 === true ||
            isInternational3 === true ||
            isInternational4 === true
          ) {
            return 10;
          }
          return 9;
        }
      };

      const urlParams = new URLSearchParams(window.location.search);

      const params = {};
      for (const [key, value] of urlParams) {
        params[key] = value;
      }

      // Validate the Url Params

      // Validator 1 : all parametrs are there ?

      if (
        params["tp"] === undefined ||
        params["tp"] === null ||
        params["tp"] === "" ||
        params["a"] === undefined ||
        params["a"] === null ||
        params["a"] === "" ||
        params["c"] === undefined ||
        params["c"] === null ||
        params["c"] === "" ||
        params["i"] === undefined ||
        params["i"] === null ||
        params["i"] === "" ||
        params["frc"] === undefined ||
        params["frc"] === null ||
        params["frc"] === "" ||
        params["frt"] === undefined ||
        params["frt"] === null ||
        params["frt"] === "" ||
        params["itr"] === undefined ||
        params["itr"] === null ||
        params["itr"] === ""
      ) {
        state.SearchResultsStatus = "idle";
        state.ErrorOnresultPage = true;
        state.ErrorOnresultPageMessageType = FlightsResultPageErrorMain.TE;
        state.ErrorOnresultPageMessageDetailed =
          FlightsResultPageErrorMainDescription.TED;
        return;
      }

      // Validator 2 : Check Individual parameters in right type ?

      // tp

      let tpp = ["ow", "rw", "mw"];

      if (!tpp.includes(params["tp"])) {
        state.SearchResultsStatus = "idle";
        state.ErrorOnresultPage = true;
        state.ErrorOnresultPageMessageType = FlightsResultPageErrorMain.TE;
        state.ErrorOnresultPageMessageDetailed =
          FlightsResultPageErrorMainDescription.TED;
        return;
      }

      // a c i

      try {
        let adult = +params["a"];
        let child = +params["c"];
        let infant = +params["i"];

        if (adult + child + infant > 9) {
          state.SearchResultsStatus = "idle";
          state.ErrorOnresultPage = true;
          state.ErrorOnresultPageMessageType = FlightsResultPageErrorMain.TE;
          state.ErrorOnresultPageMessageDetailed =
            FlightsResultPageErrorMainDescription.TED;
          return;
        }

        // a
        if (
          adult > Travellers.adults[Travellers.adults?.length - 1] ||
          adult === 0 ||
          adult < 0 ||
          infant > adult
        ) {
          state.SearchResultsStatus = "idle";
          state.ErrorOnresultPage = true;
          state.ErrorOnresultPageMessageType = FlightsResultPageErrorMain.TE;
          state.ErrorOnresultPageMessageDetailed =
            FlightsResultPageErrorMainDescription.TED;
          return;
        }

        // c
        if (
          child > Travellers.childs[Travellers.childs?.length - 1] ||
          child < 0
        ) {
          state.SearchResultsStatus = "idle";
          state.ErrorOnresultPage = true;
          state.ErrorOnresultPageMessageType = FlightsResultPageErrorMain.TE;
          state.ErrorOnresultPageMessageDetailed =
            FlightsResultPageErrorMainDescription.TED;
          return;
        }

        // i
        if (
          infant > Travellers.infants[Travellers.infants?.length - 1] ||
          infant > adult
        ) {
          state.SearchResultsStatus = "idle";
          state.ErrorOnresultPage = true;
          state.ErrorOnresultPageMessageType = FlightsResultPageErrorMain.TE;
          state.ErrorOnresultPageMessageDetailed =
            FlightsResultPageErrorMainDescription.TED;
          return;
        }
      } catch (e) {
        state.SearchResultsStatus = "idle";
        state.ErrorOnresultPage = true;
        state.ErrorOnresultPageMessageType = FlightsResultPageErrorMain.TE;
        state.ErrorOnresultPageMessageDetailed =
          FlightsResultPageErrorMainDescription.TED;
        return;
      }

      console.log(params);

      // frc

      if (!TravellerClasses.includes(params["frc"])) {
        state.SearchResultsStatus = "idle";
        state.ErrorOnresultPage = true;
        state.ErrorOnresultPageMessageType = FlightsResultPageErrorMain.TE;
        state.ErrorOnresultPageMessageDetailed =
          FlightsResultPageErrorMainDescription.TED;
        return;
      }

      // frt

      let adult = +params["a"];
      let child = +params["c"];
      let infant = +params["i"];

      if (
        !fareOptions.includes(params["frt"]) ||
        (params["frt"] === "Student" && (child > 0 || infant > 0)) ||
        (params["frt"] === "Senior Citizen" && (child > 0 || infant > 0))
      ) {
        state.SearchResultsStatus = "idle";
        state.ErrorOnresultPage = true;
        state.ErrorOnresultPageMessageType = FlightsResultPageErrorMain.TE;
        state.ErrorOnresultPageMessageDetailed =
          FlightsResultPageErrorMainDescription.TED;
        return;
      }

      // itr

      try {
        let itrSeparated = params["itr"].split("|");

        // for oneway
        if (params["tp"] === "ow") {
          if (params["itr"]?.length != 24) {
            state.SearchResultsStatus = "idle";
            state.ErrorOnresultPage = true;
            state.ErrorOnresultPageMessageType = FlightsResultPageErrorMain.TE;
            state.ErrorOnresultPageMessageDetailed =
              FlightsResultPageErrorMainDescription.TED;

            return;
          }

          let extractedDateStr = itrSeparated[0].substring(8, 18);
          let [day, month, year] = extractedDateStr.split("-").map(Number);

          // Create a date object from the extracted date
          let extractedDate = new Date(year, month - 1, day); // Months are 0-based in JavaScript

          // Get today's date (without time)
          let today = new Date();
          today.setHours(0, 0, 0, 0);

          // Calculate the date one year from today
          let oneYearFromToday = new Date(today);
          oneYearFromToday.setFullYear(today.getFullYear() + 1);

          if (extractedDate < today || extractedDate > oneYearFromToday) {
            // Set the error state
            state.SearchResultsStatus = "idle";
            state.ErrorOnresultPage = true;
            state.ErrorOnresultPageMessageType =
              FlightsResultPageErrorMain.PEFD;
            state.ErrorOnresultPageMessageDetailed =
              FlightsResultPageErrorMainDescription.PEFDD;

            return;
          }
        }

        // for roundway
        if (params["tp"] === "rw") {
          if (params["itr"]?.length != 49) {
            state.SearchResultsStatus = "idle";
            state.ErrorOnresultPage = true;
            state.ErrorOnresultPageMessageType = FlightsResultPageErrorMain.TE;
            state.ErrorOnresultPageMessageDetailed =
              FlightsResultPageErrorMainDescription.TED;
            return;
          }

          // Check departure date
          let extractedDateStr = itrSeparated[0].substring(8, 18);
          let [day, month, year] = extractedDateStr.split("-").map(Number);

          // Create a date object from the extracted date
          let extractedDate = new Date(year, month - 1, day); // Months are 0-based in JavaScript

          // Get today's date (without time)
          let today = new Date();
          today.setHours(0, 0, 0, 0);

          // Calculate the date one year from today
          let oneYearFromToday = new Date(today);
          oneYearFromToday.setFullYear(today.getFullYear() + 1);

          if (extractedDate < today || extractedDate > oneYearFromToday) {
            // Set the error state
            state.SearchResultsStatus = "idle";
            state.ErrorOnresultPage = true;
            state.ErrorOnresultPageMessageType =
              FlightsResultPageErrorMain.PEFD;
            state.ErrorOnresultPageMessageDetailed =
              FlightsResultPageErrorMainDescription.PEFDD;

            return;
          }

          // check return date
          let extractedDateStr2 = itrSeparated[1].substring(8, 18);
          let [day2, month2, year2] = extractedDateStr2.split("-").map(Number);

          // Create a date object from the extracted date
          let extractedDate2 = new Date(year2, month2 - 1, day2); // Months are 0-based in JavaScript

          if (
            extractedDate2 < extractedDate ||
            extractedDate > oneYearFromToday
          ) {
            // Set the error state
            state.SearchResultsStatus = "idle";
            state.ErrorOnresultPage = true;
            state.ErrorOnresultPageMessageType =
              FlightsResultPageErrorMain.PEFD;
            state.ErrorOnresultPageMessageDetailed =
              FlightsResultPageErrorMainDescription.PEFDD;

            return;
          }
        }

        // for multiway

        let hasDateError = false;
        if (params["tp"] === "mw") {
          let irtParams = params["itr"].split("|");

          irtParams.forEach((element) => {
            if (element?.length != 24) {
              state.SearchResultsStatus = "idle";
              state.ErrorOnresultPage = true;
              state.ErrorOnresultPageMessageType =
                FlightsResultPageErrorMain.DDNF;
              state.ErrorOnresultPageMessageDetailed =
                FlightsResultPageErrorMainDescription.DDNFD;
              return;
            }

            let extractedDateStr = element.substring(8, 18);
            let [day, month, year] = extractedDateStr.split("-").map(Number);

            // Create a date object from the extracted date
            let extractedDate = new Date(year, month - 1, day); // Months are 0-based in JavaScript

            // Get today's date (without time)
            let today = new Date();
            today.setHours(0, 0, 0, 0);

            // Calculate the date one year from today
            let oneYearFromToday = new Date(today);
            oneYearFromToday.setFullYear(today.getFullYear() + 1);

            if (extractedDate < today || extractedDate > oneYearFromToday) {
              // Set the error state
              state.SearchResultsStatus = "idle";
              state.ErrorOnresultPage = true;
              state.ErrorOnresultPageMessageType =
                FlightsResultPageErrorMain.PEFD;
              state.ErrorOnresultPageMessageDetailed =
                FlightsResultPageErrorMainDescription.PEFDD;

              hasDateError = true;
              return;
            }
          });
        }

        if (hasDateError === true) {
          return;
        }
      } catch (e) {
        state.SearchResultsStatus = "idle";
        state.ErrorOnresultPage = true;
        state.ErrorOnresultPageMessageType = FlightsResultPageErrorMain.DDNF;
        state.ErrorOnresultPageMessageDetailed =
          FlightsResultPageErrorMainDescription.DDNFD;
        return;
      }

      // Set the params and other important stuff

      // &pid= is the switched pipeline's own region code (e.g. "AU"), or "x"/absent for Global —
      // see getTheResultType()/isInternationalTrip()'s docblock for why this can't be decided
      // from the segments' own country codes alone.
      state.SearchResultType = getTheResultType(params["itr"].split("|"), params["pid"]);
      state.itrCode = params["itr"];
      // get the theme type
      if (params["frc"] === "Business" || params["frc"] === "First") {
        state.PageTheme = 2;
      }

      // set the Search Params for Search bar

      let splitTheItr = params["itr"].split("|");
      console.log("splitTheItr is : ", splitTheItr);
      // getLocalStorageJSON returns null for a key that was never set (JSON.parse(null) === null)
      // — spreading null throws "is not iterable" and crashes the whole results page. Hits any
      // fresh session landing on /flights/results directly (a shared link, bookmark, or first-ever
      // visit that skipped the homepage — so "recent airports" was never cached), not just a
      // theoretical edge case.
      let AllAvaiableAirprotsData = [
        ...(getLocalStorageJSON("fts-hm-ta") || []),
        ...(getLocalStorageJSON("fts-hm-fa") || []),
      ];

      if (params["tp"] === "ow") {
        state.searchBarMode = 1;

        let OriginData = AllAvaiableAirprotsData.filter((item) => {
          return item.airport_code === splitTheItr[0].substring(0, 3);
        })[0];

        let DestinyData = AllAvaiableAirprotsData.filter((item) => {
          return item.airport_code === splitTheItr[0].substring(4, 7);
        })[0];

        state.searchParams[0].OriginCity = OriginData.city_name;
        state.searchParams[0].DestinationCity = DestinyData.city_name;
        state.searchParams[0].OriginCode = OriginData.airport_code;
        state.searchParams[0].DestinyCode = DestinyData.airport_code;
        state.searchParams[0].Origin = OriginData.airport_name;
        state.searchParams[0].Destiny = DestinyData.airport_name;
        state.searchParams[0].OriginCountryCode = OriginData.country_code;
        state.searchParams[0].DestinationCountryCode = DestinyData.country_code;
        state.searchParams[0].OriginCountry = OriginData.country_name;
        state.searchParams[0].DestinationCountry = DestinyData.country_name;
        state.searchParams[0].OriginDate = formatDateToSeatchParams(
          splitTheItr[0].substring(8, 18)
        ); // convert date to this format;
        state.searchParams[0].ReturnDate = formatDateToSeatchParams(
          splitTheItr[0].substring(8, 18)
        ); // convert date to this format;
      } else if (params["tp"] === "rw") {
        state.searchBarMode = 2;

        let OriginData = AllAvaiableAirprotsData.filter((item) => {
          return item.airport_code === splitTheItr[0].substring(0, 3);
        })[0];

        let DestinyData = AllAvaiableAirprotsData.filter((item) => {
          return item.airport_code === splitTheItr[0].substring(4, 7);
        })[0];

        state.searchParams[0].OriginCity = OriginData.city_name;
        state.searchParams[0].DestinationCity = DestinyData.city_name;
        state.searchParams[0].OriginCode = OriginData.airport_code;
        state.searchParams[0].DestinyCode = DestinyData.airport_code;
        state.searchParams[0].Origin = OriginData.airport_name;
        state.searchParams[0].Destiny = DestinyData.airport_name;
        state.searchParams[0].OriginCountryCode = OriginData.country_code;
        state.searchParams[0].DestinationCountryCode = DestinyData.country_code;
        state.searchParams[0].OriginCountry = OriginData.country_name;
        state.searchParams[0].DestinationCountry = DestinyData.country_name;
        state.searchParams[0].OriginDate = formatDateToSeatchParams(
          splitTheItr[0].substring(8, 18)
        ); // convert date to this format;
        state.searchParams[0].ReturnDate = formatDateToSeatchParams(
          splitTheItr[1].substring(8, 18)
        ); // convert date to this format;
      } else if (params["tp"] === "mw") {
        state.searchBarMode = 3;

        let rowLength = params["itr"].split("|")?.length;

        if (rowLength === 2) {
          let date1 = splitTheItr[0].substring(8, 18);
          let date2 = splitTheItr[1].substring(8, 18);

          let extractedDateStr1 = date1.substring(8, 18);
          let [day1, month1, year1] = extractedDateStr1.split("-").map(Number);

          let extractedDateStr2 = date2.substring(8, 18);
          let [day2, month2, year2] = extractedDateStr2.split("-").map(Number);

          // Create a date object from the extracted date
          let extractedDateToCompare1 = new Date(year1, month1 - 1, day1); // Months are 0-based in JavaScript
          let extractedDateToCompare2 = new Date(year2, month2 - 1, day2); // Months are 0-based in JavaScript

          if (extractedDateToCompare2 < extractedDateToCompare1) {
            // Set the error state
            state.SearchResultsStatus = "idle";
            state.ErrorOnresultPage = true;
            state.ErrorOnresultPageMessageType =
              FlightsResultPageErrorMain.PEFD;
            state.ErrorOnresultPageMessageDetailed =
              FlightsResultPageErrorMainDescription.PEFDD;

            return;
          }
        } else if (rowLength === 3) {
          let date1 = splitTheItr[0].substring(8, 18);
          let date2 = splitTheItr[1].substring(8, 18);
          let date3 = splitTheItr[2].substring(8, 18);

          let extractedDateStr1 = date1.substring(8, 18);
          let [day1, month1, year1] = extractedDateStr1.split("-").map(Number);

          let extractedDateStr2 = date2.substring(8, 18);
          let [day2, month2, year2] = extractedDateStr2.split("-").map(Number);

          let extractedDateStr3 = date3.substring(8, 18);
          let [day3, month3, year3] = extractedDateStr3.split("-").map(Number);

          // Create a date object from the extracted date
          let extractedDateToCompare1 = new Date(year1, month1 - 1, day1); // Months are 0-based in JavaScript
          let extractedDateToCompare2 = new Date(year2, month2 - 1, day2); // Months are 0-based in JavaScript
          let extractedDateToCompare3 = new Date(year3, month3 - 1, day3); // Months are 0-based in JavaScript

          if (extractedDateToCompare2 < extractedDateToCompare1) {
            // Set the error state
            state.SearchResultsStatus = "idle";
            state.ErrorOnresultPage = true;
            state.ErrorOnresultPageMessageType =
              FlightsResultPageErrorMain.PEFD;
            state.ErrorOnresultPageMessageDetailed =
              FlightsResultPageErrorMainDescription.PEFDD;

            return;
          }
          if (extractedDateToCompare3 < extractedDateToCompare2) {
            // Set the error state
            state.SearchResultsStatus = "idle";
            state.ErrorOnresultPage = true;
            state.ErrorOnresultPageMessageType =
              FlightsResultPageErrorMain.PEFD;
            state.ErrorOnresultPageMessageDetailed =
              FlightsResultPageErrorMainDescription.PEFDD;

            return;
          }
        } else if (rowLength === 4) {
          let date1 = splitTheItr[0].substring(8, 18);
          let date2 = splitTheItr[1].substring(8, 18);
          let date3 = splitTheItr[2].substring(8, 18);
          let date4 = splitTheItr[3].substring(8, 18);

          let extractedDateStr1 = date1.substring(8, 18);
          let [day1, month1, year1] = extractedDateStr1.split("-").map(Number);

          let extractedDateStr2 = date2.substring(8, 18);
          let [day2, month2, year2] = extractedDateStr2.split("-").map(Number);

          let extractedDateStr3 = date3.substring(8, 18);
          let [day3, month3, year3] = extractedDateStr3.split("-").map(Number);

          let extractedDateStr4 = date4.substring(8, 18);
          let [day4, month4, year4] = extractedDateStr4.split("-").map(Number);

          // Create a date object from the extracted date
          let extractedDateToCompare1 = new Date(year1, month1 - 1, day1); // Months are 0-based in JavaScript
          let extractedDateToCompare2 = new Date(year2, month2 - 1, day2); // Months are 0-based in JavaScript
          let extractedDateToCompare3 = new Date(year3, month3 - 1, day3); // Months are 0-based in JavaScript
          let extractedDateToCompare4 = new Date(year4, month4 - 1, day4); // Months are 0-based in JavaScript

          if (extractedDateToCompare2 < extractedDateToCompare1) {
            // Set the error state
            state.SearchResultsStatus = "idle";
            state.ErrorOnresultPage = true;
            state.ErrorOnresultPageMessageType =
              FlightsResultPageErrorMain.PEFD;
            state.ErrorOnresultPageMessageDetailed =
              FlightsResultPageErrorMainDescription.PEFDD;

            return;
          }
          if (extractedDateToCompare3 < extractedDateToCompare2) {
            // Set the error state
            state.SearchResultsStatus = "idle";
            state.ErrorOnresultPage = true;
            state.ErrorOnresultPageMessageType =
              FlightsResultPageErrorMain.PEFD;
            state.ErrorOnresultPageMessageDetailed =
              FlightsResultPageErrorMainDescription.PEFDD;

            return;
          }
          if (extractedDateToCompare4 < extractedDateToCompare3) {
            // Set the error state
            state.SearchResultsStatus = "idle";
            state.ErrorOnresultPage = true;
            state.ErrorOnresultPageMessageType =
              FlightsResultPageErrorMain.PEFD;
            state.ErrorOnresultPageMessageDetailed =
              FlightsResultPageErrorMainDescription.PEFDD;

            return;
          }
        }

        state.multiRowNumber = rowLength;

        let OriginData1 = AllAvaiableAirprotsData.filter((item) => {
          return item.airport_code === splitTheItr[0].substring(0, 3);
        })[0];

        let DestinyData1 = AllAvaiableAirprotsData.filter((item) => {
          return item.airport_code === splitTheItr[0].substring(4, 7);
        })[0];

        let OriginData2 = AllAvaiableAirprotsData.filter((item) => {
          return item.airport_code === splitTheItr[1].substring(0, 3);
        })[0];

        let DestinyData2 = AllAvaiableAirprotsData.filter((item) => {
          return item.airport_code === splitTheItr[1].substring(4, 7);
        })[0];

        state.searchParams[0].OriginCity = OriginData1.city_name;
        state.searchParams[0].DestinationCity = DestinyData1.city_name;
        state.searchParams[0].OriginCode = OriginData1.airport_code;
        state.searchParams[0].DestinyCode = DestinyData1.airport_code;
        state.searchParams[0].Origin = OriginData1.airport_name;
        state.searchParams[0].Destiny = DestinyData1.airport_name;
        state.searchParams[0].OriginCountryCode = OriginData1.country_code;
        state.searchParams[0].DestinationCountryCode =
          DestinyData1.country_code;
        state.searchParams[0].OriginCountry = OriginData1.country_name;
        state.searchParams[0].DestinationCountry = DestinyData1.country_name;
        state.searchParams[0].OriginDate = formatDateToSeatchParams(
          splitTheItr[0].substring(8, 18)
        ); // convert date to this format;
        state.searchParams[0].ReturnDate = null; // convert date to this format;

        state.searchParams[1].OriginCity = OriginData2.city_name;
        state.searchParams[1].DestinationCity = DestinyData2.city_name;
        state.searchParams[1].OriginCode = OriginData2.airport_code;
        state.searchParams[1].DestinyCode = DestinyData2.airport_code;
        state.searchParams[1].Origin = OriginData2.airport_name;
        state.searchParams[1].Destiny = DestinyData2.airport_name;
        state.searchParams[1].OriginCountryCode = OriginData2.country_code;
        state.searchParams[1].DestinationCountryCode =
          DestinyData2.country_code;
        state.searchParams[1].OriginCountry = OriginData2.country_name;
        state.searchParams[1].DestinationCountry = DestinyData2.country_name;
        state.searchParams[1].OriginDate = formatDateToSeatchParams(
          splitTheItr[1].substring(8, 18)
        ); // convert date to this format;
        state.searchParams[1].ReturnDate = null; // convert date to this format;

        if (rowLength === 3 || rowLength === 4) {
          let OriginData3 = AllAvaiableAirprotsData.filter((item) => {
            return item.airport_code === splitTheItr[2].substring(0, 3);
          })[0];

          let DestinyData3 = AllAvaiableAirprotsData.filter((item) => {
            return item.airport_code === splitTheItr[2].substring(4, 7);
          })[0];

          state.searchParams[2].OriginCity = OriginData3.city_name;
          state.searchParams[2].DestinationCity = DestinyData3.city_name;
          state.searchParams[2].OriginCode = OriginData3.airport_code;
          state.searchParams[2].DestinyCode = DestinyData3.airport_code;
          state.searchParams[2].Origin = OriginData3.airport_name;
          state.searchParams[2].Destiny = DestinyData3.airport_name;
          state.searchParams[2].OriginCountryCode = OriginData3.country_code;
          state.searchParams[2].DestinationCountryCode =
            DestinyData3.country_code;
          state.searchParams[2].OriginCountry = OriginData3.country_name;
          state.searchParams[2].DestinationCountry = DestinyData3.country_name;
          state.searchParams[2].OriginDate = formatDateToSeatchParams(
            splitTheItr[2].substring(8, 18)
          ); // convert date to this format;
          state.searchParams[2].ReturnDate = null; // convert date to this format;
        }

        if (rowLength === 4) {
          let OriginData4 = AllAvaiableAirprotsData.filter((item) => {
            return item.airport_code === splitTheItr[3].substring(0, 3);
          })[0];

          let DestinyData4 = AllAvaiableAirprotsData.filter((item) => {
            return item.airport_code === splitTheItr[3].substring(4, 7);
          })[0];

          state.searchParams[3].OriginCity = OriginData4.city_name;
          state.searchParams[3].DestinationCity = DestinyData4.city_name;
          state.searchParams[3].OriginCode = OriginData4.airport_code;
          state.searchParams[3].DestinyCode = DestinyData4.airport_code;
          state.searchParams[3].Origin = OriginData4.airport_name;
          state.searchParams[3].Destiny = DestinyData4.airport_name;
          state.searchParams[3].OriginCountryCode = OriginData4.country_code;
          state.searchParams[3].DestinationCountryCode =
            DestinyData4.country_code;
          state.searchParams[3].OriginCountry = OriginData4.country_name;
          state.searchParams[3].DestinationCountry = DestinyData4.country_name;
          state.searchParams[3].OriginDate = formatDateToSeatchParams(
            splitTheItr[3].substring(8, 18)
          ); // convert date to this format;
          state.searchParams[3].ReturnDate = null; // convert date to this format;
        }
      }

      // set the travellers for search bar
      state.searchParamsTravellers.Adults = adult;
      state.searchParamsTravellers.Childs = child;
      state.searchParamsTravellers.Infrants = infant;

      // set the fare type and class
      state.searchParamsFare.class = params["frc"];
      state.searchParamsFare.type = params["frt"];

      // Start the Search by setting the paraams

      // This becomes the backend's cache key (returnCachedSearchIfAvailable — MainSearchHelpers.php)
      // as-is, so it must only vary by things that actually change the backend's response.
      // `vc` is purely a frontend display-currency param (useDisplayCurrency.js converts client-side
      // for display only) — the backend never reads it at all — so leaving it in would fragment the
      // cache for no reason: the same route/date/pipeline searched under INR vs AUD display currency
      // returns identical backend data, but would miss cache and re-hit the real APIs every time.
      // `pid` stays in, since a different pipeline genuinely changes what the backend searches/returns.
      const cacheKeyParams = new URLSearchParams(window.location.search);
      cacheKeyParams.delete("vc");
      // `cm` (admin's chosen cache TTL) picks how long a result gets cached, not what data comes
      // back — leaving it in would fragment the cache by TTL choice alone.
      cacheKeyParams.delete("cm");
      state.searchkey = `?${cacheKeyParams.toString()}`;

      let { location, userData, pipelineId } = action.payload;

      try {
        let Params = {
          Travellers: {
            Adults: adult,
            Childs: child,
            Infrants: infant,
          },
          User: {
            Id: userData?.id == undefined ? null : userData?.id,
            Country: {
              name: location.name,
              code: location.code,
              currency: location.currency,
              dial_code: location.dial_code,
              pipeline_id: pipelineId ?? "x",
            },
          },
          Fare: {
            class: params["frc"],
            type: params["frt"],
          },
          Segments: GenerateTheSegments(params["itr"], state.searchParams),
          searchKey: state.searchkey,
          // Admin Search Mode's cache-time popup (SearchModePopup.jsx) — carried here from the
          // URL's &cm= (see searchTheFlightUrlCreator) so cacheSearchResponseIfEligible
          // (MainSearchHelpers.php) can override its per-handler default TTL. Backend only
          // honors this for genuine admin searches (IsAdminSearch), so it's harmless to include
          // unconditionally here — undefined when a normal customer search built this URL.
          ...(params["cm"] ? { CacheMinutes: Number(params["cm"]) } : {}),
        };

        console.log("Params is : ", Params);

        state.SearchParameters = Params;
        state.StartTheSearch = true;
      } catch (e) {
        console.log("params error is : ", e);

        state.SearchResultsStatus = "idle";
        state.ErrorOnresultPage = true;
        state.ErrorOnresultPageMessageType = FlightsResultPageErrorMain.DDNF;
        state.ErrorOnresultPageMessageDetailed =
          FlightsResultPageErrorMainDescription.DDNFD;
        return;
      }
    },
    setSearchBarMode: (state, action) => {
      state.disableSearch = false;
      state.searchBarMode = action.payload;
    },
    // Region/Currency selectors (Header.jsx) now also render on the results page, but they live
    // outside this search bar's own fields (airports/dates/travellers/fare type) — none of those
    // reducers fire when only the region or currency is changed, so disableSearch was staying
    // whatever it already was (often true right after a search finishes) and the SEARCH button
    // never re-enabled. This mirrors every other "user touched a search input" reducer above.
    enableResultPageSearchButton: (state) => {
      state.disableSearch = false;
    },
    setMultiRowNumber: (state, action) => {
      state.disableSearch = false;
      state.multiRowNumber = action.payload;
    },
    setSearchClicked: (state, action) => {
      state.disableSearch = false;
      state.searchClicked = false;
    },
    setResultView: (state, action) => {
      state.ResultView = action.payload;
    },
    setbarModeSelected: (state, action) => {
      state.barModeSelected = action.payload;
    },
    setbarModeData: (state, action) => {
      state.barModeData[action.payload.mode] = action.payload.Data;
    },
    setbookLoading: (state, action) => {
      state.bookLoading = action.payload;
    },
    setbookLoadingError: (state, action) => {
      state.bookLoadingError = action.payload;
    },
    setbookLoadingErrorMessage: (state, action) => {
      state.bookLoadingErrorMessage = action.payload;
    },
    setTheFareType: (state, action) => {
      state.disableSearch = false;
      state.searchParamsFare.type = action.payload;

      const { searchParamsFare, searchParamsTravellers } = state;

      if (
        (searchParamsFare.type === "Student" ||
          searchParamsFare.type === "Senior Citizen") &&
        (searchParamsTravellers.Childs > 0 ||
          searchParamsTravellers.Infrants > 0)
      ) {
        state.searchParamsTravellers.TravellersAndClassesErrorIn = true;
        state.searchParamsTravellers.TravellersAndClassesErrorInMessage =
          TravellersFareMessage(searchParamsFare.type);
        state.searchParamsTravellers.TravellersAndClassesErrorOut = true;
        state.searchParamsTravellers.TravellersAndClassesErrorOutMessage =
          TravellersFareMessage(searchParamsFare.type);

        return;
      }

      state.searchParamsTravellers.TravellersAndClassesErrorIn = false;
      state.searchParamsTravellers.TravellersAndClassesErrorInMessage = "";
      state.searchParamsTravellers.TravellersAndClassesErrorOut = false;
      state.searchParamsTravellers.TravellersAndClassesErrorOutMessage = "";
    },
    setSearchSegmentsParams: (state, action) => {
      state.disableSearch = false;
      console.log("action.pauylaod is  : ", action.payload);
      // check if is of From or To
      if (action.payload.PopupType === 0) {
        // From
        state.searchParams[action.payload.type].OriginCity =
          action.payload.City;
        state.searchParams[action.payload.type].Origin =
          action.payload.AirportName;
        state.searchParams[action.payload.type].OriginCode =
          action.payload.Code;
        state.searchParams[action.payload.type].OriginCountryCode =
          action.payload.CountryCode;
        state.searchParams[action.payload.type].OriginCountry =
          action.payload.CountryName;

        // check if error there ,, update the error

        if (action.payload.type === 0) {
          if (state.AirportsFromError1[0] === true) {
            state.AirportsFromError1 = [false, ""];
          }
        }
        if (action.payload.type === 1) {
          if (state.AirportsFromError2[0] === true) {
            state.AirportsFromError2 = [false, ""];
          }
        }
        if (action.payload.type === 2) {
          if (state.AirportsFromError3[0] === true) {
            state.AirportsFromError3 = [false, ""];
          }
        }
        if (action.payload.type === 3) {
          if (state.AirportsFromError4[0] === true) {
            state.AirportsFromError4 = [false, ""];
          }
        }

        if (action.payload.type === 0) {
          if (
            action.payload.Code ==
            state.searchParams[action.payload.type].DestinyCode
          ) {
            state.AirportsToError1 = [true, SearchBarErrorMessages.From_To];
          } else {
            state.AirportsToError1 = [false, ""];
          }
        }
        if (action.payload.type === 1) {
          if (
            action.payload.Code ==
            state.searchParams[action.payload.type].DestinyCode
          ) {
            state.AirportsToError2 = [true, SearchBarErrorMessages.From_To];
          } else {
            state.AirportsToError2 = [false, ""];
          }
        }
        if (action.payload.type === 2) {
          if (
            action.payload.Code ==
            state.searchParams[action.payload.type].DestinyCode
          ) {
            state.AirportsToError3 = [true, SearchBarErrorMessages.From_To];
          } else {
            state.AirportsToError3 = [false, ""];
          }
        }
        if (action.payload.type === 3) {
          if (
            action.payload.Code ==
            state.searchParams[action.payload.type].DestinyCode
          ) {
            state.AirportsToError4 = [true, SearchBarErrorMessages.From_To];
          } else {
            state.AirportsToError4 = [false, ""];
          }
        }

        // Save the from airports
        const fromAirports = getLocalStorageJSON("fts-hm-fa");

        if (fromAirports?.length > 0) {
          // Check if this airport already exists
          const existingIndex = fromAirports?.findIndex(
            (airport) => airport.airport_code === action.payload.Code
          );

          if (existingIndex !== -1) {
            // If it already exists, remove it
            fromAirports.splice(existingIndex, 1);
          }
        }

        // Push the new airport to the top of the list
        fromAirports.unshift(action.payload.airport);

        // Check if the length of fromAirports is greater than 5
        if (fromAirports?.length > 16) {
          // Remove the last element
          fromAirports.pop();
        }

        // Update the state with the modified fromAirports array
        state.fromAirports = fromAirports;

        setLocalStorageJSON("fts-hm-fa", state.fromAirports);
      } else {
        // To
        state.searchParams[action.payload.type].DestinationCity =
          action.payload.City;
        state.searchParams[action.payload.type].Destiny =
          action.payload.AirportName;
        state.searchParams[action.payload.type].DestinyCode =
          action.payload.Code;
        state.searchParams[action.payload.type].DestinationCountryCode =
          action.payload.CountryCode;
        state.searchParams[action.payload.type].DestinationCountry =
          action.payload.CountryName;

        // check if error there ,, update the error

        if (action.payload.type === 0) {
          if (state.AirportsToError1[0] === true) {
            state.AirportsToError1 = [false, ""];
          }
        }
        if (action.payload.type === 1) {
          if (state.AirportsToError2[0] === true) {
            state.AirportsToError2 = [false, ""];
          }
        }
        if (action.payload.type === 2) {
          if (state.AirportsToError3[0] === true) {
            state.AirportsToError3 = [false, ""];
          }
        }
        if (action.payload.type === 3) {
          if (state.AirportsToError4[0] === true) {
            state.AirportsToError4 = [false, ""];
          }
        }

        if (action.payload.type === 0) {
          if (
            action.payload.Code ==
            state.searchParams[action.payload.type].OriginCode
          ) {
            state.AirportsToError1 = [true, SearchBarErrorMessages.From_To];
          } else {
            state.AirportsToError1 = [false, ""];
          }
        } else if (action.payload.type === 1) {
          if (
            action.payload.Code ==
            state.searchParams[action.payload.type].OriginCode
          ) {
            state.AirportsToError2 = [true, SearchBarErrorMessages.From_To];
          } else {
            state.AirportsToError2 = [false, ""];
          }
        } else if (action.payload.type === 2) {
          if (
            action.payload.Code ==
            state.searchParams[action.payload.type].OriginCode
          ) {
            state.AirportsToError3 = [true, SearchBarErrorMessages.From_To];
          } else {
            state.AirportsToError3 = [false, ""];
          }
        } else if (action.payload.type === 3) {
          if (
            action.payload.Code ==
            state.searchParams[action.payload.type].OriginCode
          ) {
            state.AirportsToError4 = [true, SearchBarErrorMessages.From_To];
          } else {
            state.AirportsToError4 = [false, ""];
          }
        }

        if (action.payload.type === 0 && state.searchBarMode === 3) {
          state.searchParams[1].OriginCity = action.payload.City;
          state.searchParams[1].Origin = action.payload.AirportName;
          state.searchParams[1].OriginCode = action.payload.Code;
          state.searchParams[1].OriginCountryCode = action.payload.CountryCode;
          state.searchParams[1].OriginCountry = action.payload.CountryName;

          if (action.payload.Code === state.searchParams[1].DestinyCode) {
            state.AirportsToError2 = [true, SearchBarErrorMessages.From_To];
          } else {
            state.AirportsToError2 = [false, ""];
          }
        } else if (action.payload.type === 1) {
          state.searchParams[2].OriginCity = action.payload.City;
          state.searchParams[2].Origin = action.payload.AirportName;
          state.searchParams[2].OriginCode = action.payload.Code;
          state.searchParams[2].OriginCountryCode = action.payload.CountryCode;
          state.searchParams[2].OriginCountry = action.payload.CountryName;

          if (action.payload.Code === state.searchParams[2].DestinyCode) {
            state.AirportsToError3 = [true, SearchBarErrorMessages.From_To];
          } else {
            state.AirportsToError3 = [false, ""];
          }
        } else if (action.payload.type === 2) {
          state.searchParams[3].OriginCity = action.payload.City;
          state.searchParams[3].Origin = action.payload.AirportName;
          state.searchParams[3].OriginCode = action.payload.Code;
          state.searchParams[3].OriginCountryCode = action.payload.CountryCode;
          state.searchParams[3].OriginCountry = action.payload.CountryName;

          if (action.payload.Code === state.searchParams[3].DestinyCode) {
            state.AirportsToError4 = [true, SearchBarErrorMessages.From_To];
          } else {
            state.AirportsToError4 = [false, ""];
          }
        }

        // save the from airports

        // Save the from airports
        const toAirports = getLocalStorageJSON("fts-hm-ta");

        if (toAirports?.length > 0) {
          // Check if this airport already exists
          const existingIndex = toAirports?.findIndex(
            (airport) => airport.airport_code === action.payload.Code
          );

          if (existingIndex !== -1) {
            // If it already exists, remove it
            toAirports.splice(existingIndex, 1);
          }
        }

        // Push the new airport to the top of the list
        toAirports.unshift(action.payload.airport);

        // Check if the length of fromAirports is greater than 5
        if (toAirports?.length > 16) {
          // Remove the last element
          toAirports.pop();
        }

        // Update the state with the modified toAirports array
        state.toAirports = toAirports;

        setLocalStorageJSON("fts-hm-ta", state.toAirports);
      }
    },
    setTheDates: (state, action) => {
      state.disableSearch = false;
      for (let i = 0; i < state.searchParams?.length; i++) {
        state.searchParams[i].OriginDate = action.payload[i].OriginDate;
        state.searchParams[i].ReturnDate = action.payload[i].ReturnDate;
      }
    },
    setTravellersAndClasses: (state, action) => {
      state.disableSearch = false;
      let { adults, childs, infants, classs } = action.payload;
      const { searchParamsFare, searchParamsTravellers } = state;

      if (adults + childs > 9) {
        state.searchParamsTravellers.TravellersAndClassesErrorIn = true;
        state.searchParamsTravellers.TravellersAndClassesErrorInMessage =
          SearchBarErrorMessages.TravellersPopup[0];

        return;
      } else if (adults < infants) {
        infants = adults;
        state.searchParamsTravellers.Adults = adults;
        state.searchParamsTravellers.Infrants = infants;

        state.searchParamsTravellers.TravellersAndClassesErrorIn = true;
        state.searchParamsTravellers.TravellersAndClassesErrorInMessage =
          SearchBarErrorMessages.TravellersPopup[1];

        return;
      }

      if (
        (searchParamsFare.type === "Student" ||
          searchParamsFare.type === "Senior Citizen") &&
        (childs > 0 || infants > 0)
      ) {
        state.searchParamsTravellers.TravellersAndClassesErrorIn = true;
        state.searchParamsTravellers.TravellersAndClassesErrorInMessage =
          TravellersFareMessage(searchParamsFare.type);
        state.searchParamsTravellers.TravellersAndClassesErrorOut = true;
        state.searchParamsTravellers.TravellersAndClassesErrorOutMessage =
          TravellersFareMessage(searchParamsFare.type);

        return;
      }

      state.searchParamsTravellers.Adults = adults;
      state.searchParamsTravellers.Childs = childs;
      state.searchParamsTravellers.Infrants = infants;
      state.searchParamsFare.class = classs;

      state.searchParamsTravellers.TravellersAndClassesErrorIn = false;
      state.searchParamsTravellers.TravellersAndClassesErrorInMessage = "";
      state.searchParamsTravellers.TravellersAndClassesErrorOut = false;
      state.searchParamsTravellers.TravellersAndClassesErrorOutMessage = "";
    },
    setTravellersErrors: (state, action) => {
      state.searchParamsTravellers.TravellersAndClassesErrorIn = false;
      state.searchParamsTravellers.TravellersAndClassesErrorInMessage = "";
      state.searchParamsTravellers.TravellersAndClassesErrorOut = false;
      state.searchParamsTravellers.TravellersAndClassesErrorOutMessage = "";
    },
    resetTheErrors: (state, action) => {
      state.searchParamsTravellers.TravellersAndClassesErrorIn = false;
      state.searchParamsTravellers.TravellersAndClassesErrorInMessage = "";
      state.searchParamsTravellers.TravellersAndClassesErrorOut = false;
      state.searchParamsTravellers.TravellersAndClassesErrorOutMessage = "";

      state.AirportsToError1 = [false, ""];
      state.AirportsToError2 = [false, ""];
      state.AirportsToError3 = [false, ""];
      state.AirportsToError4 = [false, ""];

      state.AirportsFromError1 = [false, ""];
      state.AirportsFromError2 = [false, ""];
      state.AirportsFromError3 = [false, ""];
      state.AirportsFromError4 = [false, ""];

      state.DateError1 = [false, ""];
      state.DateError11 = [false, ""];
      state.DateError2 = [false, ""];
      state.DateError3 = [false, ""];
      state.DateError4 = [false, ""];
    },
    setExchangeSearchParas: (state, action) => {
      if (
        state.searchParams[action.payload].OriginCode === "" ||
        state.searchParams[action.payload].DestinyCode === ""
      ) {
        return;
      }

      state.disableSearch = false;

      let previousOriginCityData = {
        City: state.searchParams[action.payload].OriginCity,
        AirportName: state.searchParams[action.payload].Origin,
        Code: state.searchParams[action.payload].OriginCode,
        CountryCode: state.searchParams[action.payload].OriginCountryCode,
        CountryName: state.searchParams[action.payload].OriginCountry,
      };

      let previousDestinyCityData = {
        City: state.searchParams[action.payload].DestinationCity,
        AirportName: state.searchParams[action.payload].Destiny,
        Code: state.searchParams[action.payload].DestinyCode,
        CountryCode: state.searchParams[action.payload].DestinationCountryCode,
        CountryName: state.searchParams[action.payload].DestinationCountry,
      };

      state.searchParams[action.payload].OriginCity =
        previousDestinyCityData.City;
      state.searchParams[action.payload].Origin =
        previousDestinyCityData.AirportName;
      state.searchParams[action.payload].OriginCode =
        previousDestinyCityData.Code;
      state.searchParams[action.payload].OriginCountryCode =
        previousDestinyCityData.CountryCode;
      state.searchParams[action.payload].OriginCountry =
        previousDestinyCityData.CountryName;

      state.searchParams[action.payload].DestinationCity =
        previousOriginCityData.City;
      state.searchParams[action.payload].Destiny =
        previousOriginCityData.AirportName;
      state.searchParams[action.payload].DestinyCode =
        previousOriginCityData.Code;
      state.searchParams[action.payload].DestinationCountryCode =
        previousOriginCityData.CountryCode;
      state.searchParams[action.payload].DestinationCountry =
        previousOriginCityData.CountryName;

      if (action.payload === 0) {
        // save the searcvh params

        if (state.searchBarMode === 3) {
          if (
            state.searchParams[1].OriginCode ==
            state.searchParams[1].DestinyCode
          ) {
            state.AirportsToError2 = true;
          } else {
            state.AirportsToError2 = false;
          }
        }
      }
      if (action.payload === 1) {
        // save the searcvh params

        if (
          state.searchParams[2].OriginCode === state.searchParams[2].DestinyCode
        ) {
          state.AirportsToError3 = true;
        } else {
          state.AirportsToError3 = false;
        }
      }
      if (action.payload === 2) {
        // save the searcvh params

        if (
          state.searchParams[3].OriginCode === state.searchParams[3].DestinyCode
        ) {
          state.AirportsToError4 = true;
        } else {
          state.AirportsToError4 = false;
        }
      }
      if (action.payload === 3) {
      }
    },
    searchTheFlightUrlCreator: (state, action) => {
      // Admin Search Mode's cache-time popup (SearchModePopup.jsx) — 1-10 minutes, only ever
      // present when an admin explicitly picked one there; a normal customer search's dispatch
      // carries no payload at all, so this stays undefined and &cm= is simply omitted below.
      const cacheMinutesForUrl = action.payload?.cacheMinutes;
      const cacheMinutesUrlSuffix = cacheMinutesForUrl ? `&cm=${cacheMinutesForUrl}` : "";

      // Step 1 : Check if There any Error

      // const { navigate } = action.payload;

      // For Oneway and Round
      if (state.searchBarMode === 1 || state.searchBarMode === 2) {
        let sholdReturn = 0;
        if (state.searchParams[0].OriginCode === "") {
          state.AirportsFromError1 = [true, SearchBarErrorMessages.From];
          sholdReturn++;
        }
        if (state.searchParams[0].DestinyCode === "") {
          state.AirportsToError1 = [true, SearchBarErrorMessages.To];
          sholdReturn++;
        }

        state.searchClicked = true;
        if (sholdReturn > 0) {
          return;
        }
      }

      if (state.searchBarMode === 1 || state.searchBarMode === 2) {
        let sholdReturn = 0;

        if (
          state.searchParams[0].OriginCode === state.searchParams[0].DestinyCode
        ) {
          state.AirportsToError1 = [true, SearchBarErrorMessages.From_To];
          sholdReturn++;
        }

        state.searchClicked = true;
        if (sholdReturn > 0) {
          return;
        }
      }

      if (state.searchBarMode === 1) {
        let sholdReturn = 0;

        if (state.searchParams[0].OriginDate === null) {
          state.DateError1 = [true, FlightsResultPageErrorMain.IVD];
          sholdReturn++;
        }

        state.searchClicked = true;
        if (sholdReturn > 0) {
          return;
        }
      }

      if (state.searchBarMode === 2) {
        let sholdReturn = 0;

        if (state.searchParams[0].OriginDate === null) {
          state.DateError1 = [true, FlightsResultPageErrorMain.IVD];
          sholdReturn++;
        }

        if (state.searchParams[0].ReturnDate === null) {
          state.DateError11 = [true, FlightsResultPageErrorMain.IVD];
          sholdReturn++;
        }

        state.searchClicked = true;
        if (sholdReturn > 0) {
          return;
        }
      }

      // For Multiway
      if (state.searchBarMode === 3) {
        if (state.multiRowNumber === 1) {
          let sholdReturn = 0;
          if (state.searchParams[0].OriginCode === "") {
            state.AirportsFromError1 = [true, SearchBarErrorMessages.From];
            sholdReturn++;
          }
          if (state.searchParams[0].DestinyCode === "") {
            state.AirportsToError1 = [true, SearchBarErrorMessages.To];
            sholdReturn++;
          }

          state.searchClicked = true;
          if (sholdReturn > 0) {
            return;
          }
        }

        if (state.multiRowNumber === 2) {
          let sholdReturn = 0;
          if (state.searchParams[0].OriginCode === "") {
            state.AirportsFromError1 = [true, SearchBarErrorMessages.From];
            sholdReturn++;
          }
          if (state.searchParams[0].DestinyCode === "") {
            state.AirportsToError1 = [true, SearchBarErrorMessages.To];
            sholdReturn++;
          }
          if (state.searchParams[1].OriginCode === "") {
            state.AirportsFromError2 = [true, SearchBarErrorMessages.From];
            sholdReturn++;
          }
          if (state.searchParams[1].DestinyCode === "") {
            state.AirportsToError2 = [true, SearchBarErrorMessages.To];
            sholdReturn++;
          }

          state.searchClicked = true;
          if (sholdReturn > 0) {
            return;
          }
        } else if (state.multiRowNumber === 3) {
          let sholdReturn = 0;
          if (state.searchParams[0].OriginCode === "") {
            state.AirportsFromError1 = [true, SearchBarErrorMessages.From];
            sholdReturn++;
          }
          if (state.searchParams[0].DestinyCode === "") {
            state.AirportsToError1 = [true, SearchBarErrorMessages.To];
            sholdReturn++;
          }
          if (state.searchParams[1].OriginCode === "") {
            state.AirportsFromError2 = [true, SearchBarErrorMessages.From];
            sholdReturn++;
          }
          if (state.searchParams[1].DestinyCode === "") {
            state.AirportsToError2 = [true, SearchBarErrorMessages.To];
            sholdReturn++;
          }
          if (state.searchParams[2].OriginCode === "") {
            state.AirportsFromError3 = [true, SearchBarErrorMessages.From];
            sholdReturn++;
          }
          if (state.searchParams[2].DestinyCode === "") {
            state.AirportsToError3 = [true, SearchBarErrorMessages.To];
            sholdReturn++;
          }

          state.searchClicked = true;
          if (sholdReturn > 0) {
            return;
          }
        } else if (state.multiRowNumber === 4) {
          let sholdReturn = 0;
          if (state.searchParams[0].OriginCode === "") {
            state.AirportsFromError1 = [true, SearchBarErrorMessages.From];
            sholdReturn++;
          }
          if (state.searchParams[0].DestinyCode === "") {
            state.AirportsToError1 = [true, SearchBarErrorMessages.To];
            sholdReturn++;
          }
          if (state.searchParams[1].OriginCode === "") {
            state.AirportsFromError2 = [true, SearchBarErrorMessages.From];
            sholdReturn++;
          }
          if (state.searchParams[1].DestinyCode === "") {
            state.AirportsToError2 = [true, SearchBarErrorMessages.To];
            sholdReturn++;
          }
          if (state.searchParams[2].OriginCode === "") {
            state.AirportsFromError3 = [true, SearchBarErrorMessages.From];
            sholdReturn++;
          }
          if (state.searchParams[2].DestinyCode === "") {
            state.AirportsToError3 = [true, SearchBarErrorMessages.To];
            sholdReturn++;
          }
          if (state.searchParams[3].OriginCode === "") {
            state.AirportsFromError4 = [true, SearchBarErrorMessages.From];
            sholdReturn++;
          }
          if (state.searchParams[3].DestinyCode === "") {
            state.AirportsToError4 = [true, SearchBarErrorMessages.To];
            sholdReturn++;
          }

          state.searchClicked = true;
          if (sholdReturn > 0) {
            return;
          }
        }
      }

      if (state.searchBarMode === 3) {
        if (state.multiRowNumber === 1) {
          let sholdReturn = 0;

          if (
            state.searchParams[0].OriginCode ==
            state.searchParams[0].DestinyCode
          ) {
            state.AirportsToError1 = [true, SearchBarErrorMessages.From_To];
            sholdReturn++;
          }

          state.searchClicked = true;
          if (sholdReturn > 0) {
            return;
          }
        }

        if (state.multiRowNumber === 2) {
          let sholdReturn = 0;

          if (
            state.searchParams[0].OriginCode ==
            state.searchParams[0].DestinyCode
          ) {
            state.AirportsToError1 = [true, SearchBarErrorMessages.From_To];
            sholdReturn++;
          }

          if (
            state.searchParams[1].OriginCode ==
            state.searchParams[1].DestinyCode
          ) {
            state.AirportsToError2 = [true, SearchBarErrorMessages.From_To];
            sholdReturn++;
          }

          state.searchClicked = true;
          if (sholdReturn > 0) {
            return;
          }
        } else if (state.multiRowNumber === 3) {
          let sholdReturn = 0;

          if (
            state.searchParams[0].OriginCode ==
            state.searchParams[0].DestinyCode
          ) {
            state.AirportsToError1 = [true, SearchBarErrorMessages.From_To];
            sholdReturn++;
          }

          if (
            state.searchParams[1].OriginCode ==
            state.searchParams[1].DestinyCode
          ) {
            state.AirportsToError2 = [true, SearchBarErrorMessages.From_To];
            sholdReturn++;
          }

          if (
            state.searchParams[2].OriginCode ==
            state.searchParams[2].DestinyCode
          ) {
            state.AirportsToError3 = [true, SearchBarErrorMessages.From_To];
            sholdReturn++;
          }

          state.searchClicked = true;
          if (sholdReturn > 0) {
            return;
          }
        } else if (state.multiRowNumber === 4) {
          let sholdReturn = 0;

          if (
            state.searchParams[0].OriginCode ==
            state.searchParams[0].DestinyCode
          ) {
            state.AirportsToError1 = [true, SearchBarErrorMessages.From_To];
            sholdReturn++;
          }

          if (
            state.searchParams[1].OriginCode ==
            state.searchParams[1].DestinyCode
          ) {
            state.AirportsToError2 = [true, SearchBarErrorMessages.From_To];
            sholdReturn++;
          }

          if (
            state.searchParams[2].OriginCode ==
            state.searchParams[2].DestinyCode
          ) {
            state.AirportsToError3 = [true, SearchBarErrorMessages.From_To];
            sholdReturn++;
          }

          if (
            state.searchParams[3].OriginCode ==
            state.searchParams[3].DestinyCode
          ) {
            state.AirportsToError4 = [true, SearchBarErrorMessages.From_To];
            sholdReturn++;
          }

          state.searchClicked = true;
          if (sholdReturn > 0) {
            return;
          }
        }
      }

      if (state.searchBarMode === 3) {
        if (state.multiRowNumber === 1) {
          let sholdReturn = 0;

          if (state.searchParams[0].OriginDate === null) {
            state.DateError1 = [true, FlightsResultPageErrorMain.IVD];
            sholdReturn++;
          }

          state.searchClicked = true;
          if (sholdReturn > 0) {
            return;
          }
        }

        if (state.multiRowNumber === 2) {
          let sholdReturn = 0;

          if (state.searchParams[0].OriginDate === null) {
            state.DateError1 = [true, FlightsResultPageErrorMain.IVD];
            sholdReturn++;
          }

          if (state.searchParams[1].OriginDate === null) {
            state.DateError2 = [true, FlightsResultPageErrorMain.IVD];
            sholdReturn++;
          }

          state.searchClicked = true;
          if (sholdReturn > 0) {
            return;
          }
        } else if (state.multiRowNumber === 3) {
          let sholdReturn = 0;

          if (state.searchParams[0].OriginDate === null) {
            state.DateError1 = [true, FlightsResultPageErrorMain.IVD];
            sholdReturn++;
          }

          if (state.searchParams[1].OriginDate === null) {
            state.DateError2 = [true, FlightsResultPageErrorMain.IVD];
            sholdReturn++;
          }

          if (state.searchParams[2].OriginDate === null) {
            state.DateError3 = [true, FlightsResultPageErrorMain.IVD];
            sholdReturn++;
          }

          state.searchClicked = true;
          if (sholdReturn > 0) {
            return;
          }
        } else if (state.multiRowNumber === 4) {
          let sholdReturn = 0;
          if (state.searchParams[0].OriginDate === null) {
            state.DateError1 = [true, FlightsResultPageErrorMain.IVD];
            sholdReturn++;
          }

          if (state.searchParams[1].OriginDate === null) {
            state.DateError2 = [true, FlightsResultPageErrorMain.IVD];
            sholdReturn++;
          }

          if (state.searchParams[2].OriginDate === null) {
            state.DateError3 = [true, FlightsResultPageErrorMain.IVD];
            sholdReturn++;
          }

          if (state.searchParams[3].OriginDate === null) {
            state.DateError4 = [true, FlightsResultPageErrorMain.IVD];
            sholdReturn++;
          }

          state.searchClicked = true;
          if (sholdReturn > 0) {
            return;
          }
        }
      }

      // For Oneway and Round
      if (state.searchBarMode === 1 || state.searchBarMode === 2) {
        if (
          state.AirportsToError1[0] === true ||
          state.AirportsToError2[0] === true ||
          state.AirportsToError3[0] === true ||
          state.AirportsToError4[0] === true ||
          state.AirportsFromError1[0] === true ||
          state.AirportsFromError2[0] === true ||
          state.AirportsFromError3[0] === true ||
          state.AirportsFromError4[0] === true ||
          state.searchParamsTravellers.TravellersAndClassesErrorIn === true ||
          state.searchParamsTravellers.TravellersAndClassesErrorOut === true
        ) {
          state.searchClicked = true;
          return;
        }
      }

      // For Multiway
      if (state.searchBarMode === 3) {
        if (state.multiRowNumber === 1) {
          if (
            state.AirportsToError1[0] === true ||
            state.AirportsFromError1[0] === true ||
            state.searchParamsTravellers.TravellersAndClassesErrorOut ===
              true ||
            state.searchParamsTravellers.TravellersAndClassesErrorIn === true
          ) {
            state.searchClicked = true;
            return;
          }
        } else if (state.multiRowNumber === 2) {
          if (
            state.AirportsToError1[0] === true ||
            state.AirportsToError2[0] === true ||
            state.AirportsFromError1[0] === true ||
            state.AirportsFromError2[0] === true ||
            state.searchParamsTravellers.TravellersAndClassesErrorOut ===
              true ||
            state.searchParamsTravellers.TravellersAndClassesErrorIn === true
          ) {
            state.searchClicked = true;
            return;
          }
        } else if (state.multiRowNumber === 3) {
          if (
            state.AirportsToError1[0] === true ||
            state.AirportsToError2[0] === true ||
            state.AirportsToError3[0] === true ||
            state.AirportsFromError1[0] === true ||
            state.AirportsFromError2[0] === true ||
            state.AirportsFromError3[0] === true ||
            state.searchParamsTravellers.TravellersAndClassesErrorOut ===
              true ||
            state.searchParamsTravellers.TravellersAndClassesErrorIn === true
          ) {
            state.searchClicked = true;
            return;
          }
        } else if (state.multiRowNumber === 4) {
          if (
            state.AirportsToError1[0] === true ||
            state.AirportsToError2[0] === true ||
            state.AirportsToError3[0] === true ||
            state.AirportsToError4[0] === true ||
            state.AirportsFromError1[0] === true ||
            state.AirportsFromError2[0] === true ||
            state.AirportsFromError3[0] === true ||
            state.AirportsFromError4[0] === true ||
            state.searchParamsTravellers.TravellersAndClassesErrorOut ===
              true ||
            state.searchParamsTravellers.TravellersAndClassesErrorIn === true
          ) {
            state.searchClicked = true;
            return;
          }
        }
      }

      // Step 2 : Create The Url accoridng to flight

      // For Oneway
      if (state.searchBarMode === 1) {
        let url = `tp=ow&a=${state.searchParamsTravellers.Adults}&c=${
          state.searchParamsTravellers.Childs
        }&i=${state.searchParamsTravellers.Infrants}&frc=${
          state.searchParamsFare.class
        }&frt=${state.searchParamsFare.type}&itr=${
          state.searchParams[0].OriginCode
        }-${state.searchParams[0].DestinyCode}-${formatDateToSeatchParams(
          state.searchParams[0].OriginDate
        )}-${state.searchParams[0].OriginCountryCode}-${
          state.searchParams[0].DestinationCountryCode
        }`;

        window.location.replace(
          `/flights/results?${url}&vc=${getSelectedCurrencyForUrl()}&pid=${getSelectedPipelineIdForUrl()}${cacheMinutesUrlSuffix}`
        );
      }
      // navigate(`/flights/results?${url}`);

      // For Roundway
      if (state.searchBarMode === 2) {
        let url = `tp=rw&a=${state.searchParamsTravellers.Adults}&c=${
          state.searchParamsTravellers.Childs
        }&i=${state.searchParamsTravellers.Infrants}&frc=${
          state.searchParamsFare.class
        }&frt=${state.searchParamsFare.type}&itr=${
          state.searchParams[0].OriginCode
        }-${state.searchParams[0].DestinyCode}-${formatDateToSeatchParams(
          state.searchParams[0].OriginDate
        )}-${state.searchParams[0].OriginCountryCode}-${
          state.searchParams[0].DestinationCountryCode
        }|${state.searchParams[0].DestinyCode}-${
          state.searchParams[0].OriginCode
        }-${formatDateToSeatchParams(state.searchParams[0].ReturnDate)}-${
          state.searchParams[0].DestinationCountryCode
        }-${state.searchParams[0].OriginCountryCode}`;

        window.location.replace(
          `/flights/results?${url}&vc=${getSelectedCurrencyForUrl()}&pid=${getSelectedPipelineIdForUrl()}${cacheMinutesUrlSuffix}`
        );
      }

      // For Multiway
      if (state.searchBarMode === 3) {
        if (state.multiRowNumber === 1) {
          let url = `tp=ow&a=${state.searchParamsTravellers.Adults}&c=${
            state.searchParamsTravellers.Childs
          }&i=${state.searchParamsTravellers.Infrants}&frc=${
            state.searchParamsFare.class
          }&frt=${state.searchParamsFare.type}&itr=${
            state.searchParams[0].OriginCode
          }-${state.searchParams[0].DestinyCode}-${formatDateToSeatchParams(
            state.searchParams[0].OriginDate
          )}-${state.searchParams[0].OriginCountryCode}-${
            state.searchParams[0].DestinationCountryCode
          }`;

          window.location.replace(
          `/flights/results?${url}&vc=${getSelectedCurrencyForUrl()}&pid=${getSelectedPipelineIdForUrl()}${cacheMinutesUrlSuffix}`
        );
        } else if (state.multiRowNumber === 2) {
          let url = `tp=${
            state.searchParams[0].OriginCode ==
            state.searchParams[1].DestinyCode
              ? "rw"
              : "mw"
          }&a=${state.searchParamsTravellers.Adults}&c=${
            state.searchParamsTravellers.Childs
          }&i=${state.searchParamsTravellers.Infrants}&frc=${
            state.searchParamsFare.class
          }&frt=${state.searchParamsFare.type}&itr=${
            state.searchParams[0].OriginCode
          }-${state.searchParams[0].DestinyCode}-${formatDateToSeatchParams(
            state.searchParams[0].OriginDate
          )}-${state.searchParams[0].OriginCountryCode}-${
            state.searchParams[0].DestinationCountryCode
          }|${state.searchParams[1].OriginCode}-${
            state.searchParams[1].DestinyCode
          }-${formatDateToSeatchParams(state.searchParams[1].OriginDate)}-${
            state.searchParams[1].OriginCountryCode
          }-${state.searchParams[1].DestinationCountryCode}`;

          window.location.replace(
          `/flights/results?${url}&vc=${getSelectedCurrencyForUrl()}&pid=${getSelectedPipelineIdForUrl()}${cacheMinutesUrlSuffix}`
        );
        } else if (state.multiRowNumber === 3) {
          let url = `tp=mw&a=${state.searchParamsTravellers.Adults}&c=${
            state.searchParamsTravellers.Childs
          }&i=${state.searchParamsTravellers.Infrants}&frc=${
            state.searchParamsFare.class
          }&frt=${state.searchParamsFare.type}&itr=${
            state.searchParams[0].OriginCode
          }-${state.searchParams[0].DestinyCode}-${formatDateToSeatchParams(
            state.searchParams[0].OriginDate
          )}-${state.searchParams[0].OriginCountryCode}-${
            state.searchParams[0].DestinationCountryCode
          }|${state.searchParams[1].OriginCode}-${
            state.searchParams[1].DestinyCode
          }-${formatDateToSeatchParams(state.searchParams[1].OriginDate)}-${
            state.searchParams[1].OriginCountryCode
          }-${state.searchParams[1].DestinationCountryCode}|${
            state.searchParams[2].OriginCode
          }-${state.searchParams[2].DestinyCode}-${formatDateToSeatchParams(
            state.searchParams[2].OriginDate
          )}-${state.searchParams[2].OriginCountryCode}-${
            state.searchParams[2].DestinationCountryCode
          }`;

          window.location.replace(
          `/flights/results?${url}&vc=${getSelectedCurrencyForUrl()}&pid=${getSelectedPipelineIdForUrl()}${cacheMinutesUrlSuffix}`
        );
        } else if (state.multiRowNumber === 4) {
          let url = `tp=mw&a=${state.searchParamsTravellers.Adults}&c=${
            state.searchParamsTravellers.Childs
          }&i=${state.searchParamsTravellers.Infrants}&frc=${
            state.searchParamsFare.class
          }&frt=${state.searchParamsFare.type}&itr=${
            state.searchParams[0].OriginCode
          }-${state.searchParams[0].DestinyCode}-${formatDateToSeatchParams(
            state.searchParams[0].OriginDate
          )}-${state.searchParams[0].OriginCountryCode}-${
            state.searchParams[0].DestinationCountryCode
          }|${state.searchParams[1].OriginCode}-${
            state.searchParams[1].DestinyCode
          }-${formatDateToSeatchParams(state.searchParams[1].OriginDate)}-${
            state.searchParams[1].OriginCountryCode
          }-${state.searchParams[1].DestinationCountryCode}|${
            state.searchParams[2].OriginCode
          }-${state.searchParams[2].DestinyCode}-${formatDateToSeatchParams(
            state.searchParams[2].OriginDate
          )}-${state.searchParams[2].OriginCountryCode}-${
            state.searchParams[2].DestinationCountryCode
          }|${state.searchParams[3].OriginCode}-${
            state.searchParams[3].DestinyCode
          }-${formatDateToSeatchParams(state.searchParams[3].OriginDate)}-${
            state.searchParams[3].OriginCountryCode
          }-${state.searchParams[3].DestinationCountryCode}`;

          window.location.replace(
          `/flights/results?${url}&vc=${getSelectedCurrencyForUrl()}&pid=${getSelectedPipelineIdForUrl()}${cacheMinutesUrlSuffix}`
        );
        }
      }
    },
    setFiltersFinalUpdate: (state, action) => {
      state.filtersGenerated = action.payload;
      state.filtersLoading = false;
    },
    SearchTheFligthFromCalendarBar: (state, action) => {
      if (state.searchBarMode === 1) {
        let url = `tp=ow&a=${state.SearchParameters.Travellers.Adults}&c=${state.SearchParameters.Travellers.Childs}&i=${state.SearchParameters.Travellers.Infrants}&frc=${state.SearchParameters.Fare.class}&frt=${state.SearchParameters.Fare.type}&itr=${state.SearchParameters.Segments[0].Origin}-${state.SearchParameters.Segments[0].Destination}-${action.payload}-${state.SearchParameters.Segments[0].OriginCountryCode}-${state.SearchParameters.Segments[0].DestinationCountryCode}`;

        window.location.replace(
          `/flights/results?${url}&vc=${getSelectedCurrencyForUrl()}&pid=${getSelectedPipelineIdForUrl()}`
        );
      }
    },
    setFilteredData: (state, action) => {
      state.FilteredData = action.payload;
    },
    // payload: { index, value } — index 0 = Onward, 1 = Return (see onlyMultiFF's own docblock).
    setOnlyMultiFF: (state, action) => {
      state.onlyMultiFF[action.payload.index] = action.payload.value;
    },
    setFiltersAppliedManual: (state, action) => {
      state.FiltersApplied = action.payload;
    },
    setbarModeDataInitial: (state, action) => {
      state.barModeData = action.payload;
    },
    setopenMainPopup: (state, action) => {
      state.openMainPopup = action.payload;
    },
    setdataMainPopup: (state, action) => {
      state.dataMainPopup = action.payload;
    },
    // Round-trip's own combined Less/Reward result (the FULL object — minus_amount,
    // coupon_1/2_value/name/show, show_bank_offers, etc., all full-booking-scale — same shape
    // useCombinedFeesAutoFetch()'s .data already returns) comes from that hook's auto-fetch in
    // ResultBarSection.jsx, which has no other way to reach MainPopup's component tree (a
    // completely separate branch, only connected via this same Redux slice) — stamped here
    // alongside dataMainPopup right when CONTINUE is clicked, so BottomBar's own Fare Summary
    // total AND coupon badge can both pick it up too.
    setCombinedFeesDiscountMainPopup: (state, action) => {
      state.combinedFeesDiscountMainPopup = action.payload;
    },
    setResultTypeMainPopup: (state, action) => {
      state.ResultTypeMainPopup = action.payload;
    },
    setFFSelectedMain: (state, action) => {
      state.FFSelected = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(SearchTheFlights.pending, (state) => {
        state.SearchResultsStatus = "Loading";
      })
      .addCase(SearchTheFlights.fulfilled, (state, action) => {
        // SearchResultType

        state.StartTheSearch = false;
        state.SearchResultsStatus = "idle";

        if (action.payload?.["Data Available"] === false) {
          state.ErrorOnresultPage = true;
          state.ErrorOnresultPageMessageType = FlightsResultPageErrorMain.FNA;
          state.ErrorOnresultPageMessageDetailed =
            FlightsResultPageErrorMainDescription.FNAD;
        }
        state.SearchResults = action.payload;
        state.FullDataInitial = action.payload.Data;
        state.FilteredData = action.payload.Data;
      })
      .addCase(SearchTheFlights.rejected, (state, action) => {
        state.SearchResultsStatus = "idle";
        state.SearchResults = null;

        // User navigated away (browser back/forward — see ResultPage.jsx's popstate handler —
        // or a tab close) before the search finished, and it got aborted on purpose. Redux
        // Toolkit itself flags this as action.meta.aborted; the payload's own `aborted` flag
        // (set in the thunk's catch block) covers it too. Either way, no error UI — the user's
        // already navigating elsewhere, nothing to show them here.
        if (action.meta?.aborted || action.payload?.aborted) {
          return;
        }

        if (
          action.error.code === "ERR_NETWORK" ||
          action.error.name === "TypeError"
        ) {
          state.ErrorOnresultPage = true;
          state.ErrorOnresultPageMessageType = FlightsResultPageErrorMain.IC;
          state.ErrorOnresultPageMessageDetailed =
            FlightsResultPageErrorMainDescription.ICD;
          state.popularCitiesLoading = false;

          return;
        } else if (action.payload.errorcode === "SERVER DOWN") {
          state.ErrorOnresultPage = true;
          state.ErrorOnresultPageMessageType = FlightsResultPageErrorMain?.SRD;
          state.ErrorOnresultPageMessageDetailed =
            FlightsResultPageErrorMainDescription?.SRDD;
          state.popularCitiesLoading = false;
          return;
        } else if (action.payload.errorcode === "ERR_BAD_REQUEST") {
          state.ErrorOnresultPage = true;
          state.ErrorOnresultPageMessageType =
            FlightsResultPageErrorMain?.[action.payload.dd.code];
          state.ErrorOnresultPageMessageDetailed =
            action.payload.dd.message ??
            FlightsResultPageErrorMainDescription?.[
              action.payload.dd.code + "D"
            ];
          state.popularCitiesLoading = false;
          return;
        } else if (action.payload.errorcode === "ERR_BAD_RESPONSE") {
          state.ErrorOnresultPage = true;
          state.ErrorOnresultPageMessageType = FlightsResultPageErrorMain.TE;
          state.ErrorOnresultPageMessageDetailed =
            FlightsResultPageErrorMainDescription.TED;
          return;
        }
      });
  },
});

export const {
  resetResultPageState,
  getUrlParams,
  setSearchBarMode,
  enableResultPageSearchButton,
  setResultView,
  setMultiRowNumber,
  setSearchClicked,
  resetTheErrors,
  setTheFareType,
  setSearchSegmentsParams,
  setTheDates,
  setTravellersAndClasses,
  setTravellersErrors,
  setExchangeSearchParas,
  searchTheFlightUrlCreator,

  setFiltersFinalUpdate,
  setbarModeSelected,

  SearchTheFligthFromCalendarBar,
  setbarModeData,
  setFilteredData,
  setOnlyMultiFF,

  setFiltersAppliedManual,

  setbarModeDataInitial,
  setPopupMode,
  setPopupTopBarMode,
  setopenMainPopup,
  setdataMainPopup,
  setCombinedFeesDiscountMainPopup,
  setResultTypeMainPopup,
  setFFSelectedMain,

  setbookLoading,
  setbookLoadingError,
  setbookLoadingErrorMessage,
} = ResultPageFlightsFlightSlice.actions;

export default ResultPageFlightsFlightSlice.reducer;
